/* tslint:disable */
/* eslint-disable */
/**
 * B2B Lodging
 * Endpoints to support Lodging  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.volume`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.lodging.cancel.policy.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `tenantid` * `b2bportal.lodging.cancel.policy.success`   * tags: `api_version`, `cancel_scenario`, `tenantid` * `b2bportal.lodging.change.policy.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `tenantid` * `b2bportal.lodging.change.policy.success`   * tags: `api_version`, `cancel_scenario`, `tenantid` * `b2bportal.lodging.room_shop.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.lodging.room_shop.success`   * tags: `api_version`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `bad_request` * `client_not_defined` * `frequent_guest_number_required` * `internal_error` * `invalid_quote` * `lack_of_inventory` * `minimum_check_in_age_not_met` * `offer_not_found` * `payment_failed` * `product_not_found` * `provider_not_defined` * `quote_expired` * `rate_not_available` * `request_deserialization_error` * `response_serialization_error` * `unavailable` * `unknown` * `unspecified`  # Cancel Scenarios * `canceled` * `cancellation_failure` * `complex_fully_refundable` * `complex_partially_refundable` * `contact_customer_service` * `full_refund` * `non_refundable` * `partial_refund` * `pending`
 *
 * The version of the OpenAPI document: v5p128
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
export interface AdditionalInfo {
    'sessionId'?: string;
}
/**
 * The kind of promotion that is being advertised
 * @export
 * @enum {string}
 */

export const AdvertisedPromotionKind = {
    DealOfTheDay: 'DealOfTheDay',
    EarlyBird: 'EarlyBird',
    FlashSale: 'FlashSale',
    Generic: 'Generic',
    LastMinute: 'LastMinute',
    NewHotel: 'NewHotel',
    Valentine: 'Valentine'
} as const;

export type AdvertisedPromotionKind = typeof AdvertisedPromotionKind[keyof typeof AdvertisedPromotionKind];


export const Amenity = {
    Accessibility: 'Accessibility',
    AccessibleBathroom: 'AccessibleBathroom',
    AdultsOnly: 'AdultsOnly',
    AirConditioning: 'AirConditioning',
    AirportTransportation: 'AirportTransportation',
    AirportTransportationAvailableGeneral: 'AirportTransportationAvailableGeneral',
    Arcade: 'Arcade',
    AtmBanking: 'AtmBanking',
    Bar: 'Bar',
    BarOrLounge: 'BarOrLounge',
    BarbecueGrill: 'BarbecueGrill',
    Beach: 'Beach',
    BeachEssentials: 'BeachEssentials',
    BigBath: 'BigBath',
    BrailleOrRaisedSignage: 'BrailleOrRaisedSignage',
    BreakfastIncluded: 'BreakfastIncluded',
    BusinessCenter: 'BusinessCenter',
    BusinessFacilities: 'BusinessFacilities',
    Casino: 'Casino',
    Childcare: 'Childcare',
    CoffeeMaker: 'CoffeeMaker',
    CoffeeTea: 'CoffeeTea',
    ComputerStation: 'ComputerStation',
    ConciergeServices: 'ConciergeServices',
    ConferenceSpace: 'ConferenceSpace',
    Dinner: 'Dinner',
    DryCleaningLaundryService: 'DryCleaningLaundryService',
    ElectricCarCharging: 'ElectricCarCharging',
    Entertainment: 'Entertainment',
    ExpressCheckIn: 'ExpressCheckIn',
    FitnessCenter: 'FitnessCenter',
    FitnessFacilities: 'FitnessFacilities',
    FreeAirportTransportation: 'FreeAirportTransportation',
    FreeBreakfast: 'FreeBreakfast',
    FreeSelfParking: 'FreeSelfParking',
    FreeWifi: 'FreeWifi',
    FullServiceSpa: 'FullServiceSpa',
    Garden: 'Garden',
    Golf: 'Golf',
    HairDryer: 'HairDryer',
    HairSalon: 'HairSalon',
    Heating: 'Heating',
    HikingOrBikingNearby: 'HikingOrBikingNearby',
    HomeEssentials: 'HomeEssentials',
    HomeInfo: 'HomeInfo',
    HotSpring: 'HotSpring',
    HotTub: 'HotTub',
    InRoomAccessibility: 'InRoomAccessibility',
    IndoorPool: 'IndoorPool',
    JapaneseStyle: 'JapaneseStyle',
    KidFriendly: 'KidFriendly',
    KitchenEssentials: 'KitchenEssentials',
    Laundry: 'Laundry',
    LaundryFacilities: 'LaundryFacilities',
    Library: 'Library',
    LuggageStorage: 'LuggageStorage',
    MeetingRooms: 'MeetingRooms',
    NaturalSpring: 'NaturalSpring',
    Nightclub: 'Nightclub',
    NumberOfBarsOrLounges: 'NumberOfBarsOrLounges',
    NumberOfRestaurants: 'NumberOfRestaurants',
    OpenAirBath: 'OpenAirBath',
    OutdoorPool: 'OutdoorPool',
    OutdoorSeasonalPool: 'OutdoorSeasonalPool',
    OutdoorSpace: 'OutdoorSpace',
    PaidBreakfast: 'PaidBreakfast',
    PaidSelfParking: 'PaidSelfParking',
    PaidValetParking: 'PaidValetParking',
    Parking: 'Parking',
    ParkingAvailableGeneral: 'ParkingAvailableGeneral',
    PetFriendly: 'PetFriendly',
    PetsAllowed: 'PetsAllowed',
    PetsAllowedNoFees: 'PetsAllowedNoFees',
    PetsOnlyCats: 'PetsOnlyCats',
    PetsOnlyDogs: 'PetsOnlyDogs',
    PetsOnlyDogsAndCats: 'PetsOnlyDogsAndCats',
    Pool: 'Pool',
    PoolGeneral: 'PoolGeneral',
    PoolsideBar: 'PoolsideBar',
    PorterBellhop: 'PorterBellhop',
    PrivateBath: 'PrivateBath',
    PrivateOpenAirBath: 'PrivateOpenAirBath',
    Restaurant: 'Restaurant',
    RollInShower: 'RollInShower',
    RoomWifi: 'RoomWifi',
    RoundTheClockCheckIn: 'RoundTheClockCheckIn',
    SafeDepositBoxFrontDesk: 'SafeDepositBoxFrontDesk',
    Sauna: 'Sauna',
    Smoking: 'Smoking',
    SnackOrDeli: 'SnackOrDeli',
    SomeAccessibilityFeaturesAvailableGeneral: 'SomeAccessibilityFeaturesAvailableGeneral',
    Spa: 'Spa',
    SpaTreatmentRoom: 'SpaTreatmentRoom',
    SteamRoom: 'SteamRoom',
    SwimmingPool: 'SwimmingPool',
    Tennis: 'Tennis',
    Terrace: 'Terrace',
    ToursTicketAssistance: 'ToursTicketAssistance',
    TwentyFourHourFitnessFacilities: 'TwentyFourHourFitnessFacilities',
    TwentyFourHourFrontDesk: 'TwentyFourHourFrontDesk',
    WaterPark: 'WaterPark',
    WesternStyle: 'WesternStyle',
    WheelchairAccessibleParking: 'WheelchairAccessibleParking',
    WheelchairAccessiblePathOfTravel: 'WheelchairAccessiblePathOfTravel',
    Workspace: 'Workspace'
} as const;

export type Amenity = typeof Amenity[keyof typeof Amenity];


export interface AmenityStatus {
    'amenity': Amenity;
    'displayName': string;
    'details'?: string;
}


/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
export interface Ancillary {
    'CfarBrand': CfarBrandEnum;
}


export interface Anytime {
    'CheckInTime': CheckInTimeEnum;
}


/**
 * Amount charged through ApplePay
 * @export
 * @interface ApplePay
 */
export interface ApplePay {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


export const Assistance = {
    BLND: 'BLND',
    DEAF: 'DEAF',
    STCR: 'STCR',
    WCBD: 'WCBD',
    WCBW: 'WCBW',
    WCHC: 'WCHC',
    WCHR: 'WCHR',
    WCHS: 'WCHS',
    WCLB: 'WCLB',
    WCMP: 'WCMP',
    WCOB: 'WCOB'
} as const;

export type Assistance = typeof Assistance[keyof typeof Assistance];


export const AutocompleteCategory = {
    airports: 'airports',
    cities: 'cities',
    emptyMatch: 'emptyMatch',
    featuredGetaways: 'featuredGetaways',
    hotelMarkets: 'hotelMarkets',
    nearby: 'nearby',
    places: 'places',
    recentSearches: 'recentSearches'
} as const;

export type AutocompleteCategory = typeof AutocompleteCategory[keyof typeof AutocompleteCategory];


export interface AvailabilityLodgingDataCorporateTravel {
    'policyCompliance': PolicyCompliance;
}
/**
 * @type AvailabilityRequest
 * request for available lodging
 * @export
 */
export type AvailabilityRequest = { AvailabilityRequest: 'FollowUpSearch' } & FollowUpSearch | { AvailabilityRequest: 'InitialSearch' } & InitialSearch;

export const AvailabilityRequestEnum = {
    FollowUpSearch: 'FollowUpSearch',
    InitialSearch: 'InitialSearch'
} as const;

export type AvailabilityRequestEnum = typeof AvailabilityRequestEnum[keyof typeof AvailabilityRequestEnum];


/**
 * @type AvailabilityResponse
 * response for available rooms
 * @export
 */
export type AvailabilityResponse = { AvailabilityResponse: 'Initial' } & Initial | { AvailabilityResponse: 'More' } & More;

export const AvailabilityResponseEnum = {
    Initial: 'Initial',
    More: 'More'
} as const;

export type AvailabilityResponseEnum = typeof AvailabilityResponseEnum[keyof typeof AvailabilityResponseEnum];


/**
 * Strategy for availability request. Default is thorough. Must follow up with thorough for full results when using fast.

* `Fast` - Returns availability for a subset of providers that are fast, faster but less comprehensive.
* `Thorough` - Returns availability for all providers, slower but more comprehensive.
 * @export
 * @enum {string}
 */

export const AvailabilityStrategy = {
    Fast: 'Fast',
    Thorough: 'Thorough'
} as const;

export type AvailabilityStrategy = typeof AvailabilityStrategy[keyof typeof AvailabilityStrategy];


export interface Available {
    'startTime': string;
    'endTime': string;
    'EffectiveRange': EffectiveRangeEnum;
}


export const BedType = {
    Dorm: 'Dorm',
    Double: 'Double',
    Full: 'Full',
    Futon: 'Futon',
    King: 'King',
    Murphy: 'Murphy',
    Queen: 'Queen',
    RunOfTheHouse: 'RunOfTheHouse',
    Single: 'Single',
    Sofa: 'Sofa',
    Tatami: 'Tatami',
    Twin: 'Twin',
    Water: 'Water'
} as const;

export type BedType = typeof BedType[keyof typeof BedType];


export interface BedTypeList {
    'bedTypes': Array<BedTypeWithDescription>;
    'description': string;
}
export interface BedTypeWithDescription {
    'bedType': BedType;
    'description': string;
}


export interface BookPollResponse {
    'purchaseResult': ReservationResponse;
}
/**
 * Request to schedule a booking

 * `personId` - individual whose name is on the hotel reservation
 * `additionalGuests` - additional names to be added to the hotel reservation
 * `token` - random UUID used to identify the lodging session
 * @export
 * @interface BookScheduleRequest
 */
export interface BookScheduleRequest {
    /**
     * individual whose name is on the hotel reservation
     * @type {string}
     * @memberof BookScheduleRequest
     */
    'personId': string;
    'phoneNumber': string;
    'emailAddress': string;
    /**
     * additional names to be added to the hotel reservation
     * @type {Array<string>}
     * @memberof BookScheduleRequest
     */
    'additionalGuests': Array<string>;
    /**
     * random UUID used to identify the lodging session
     * @type {string}
     * @memberof BookScheduleRequest
     */
    'token': string;
}
/**
 * booked ancillary ids attached to lodging reservation
 * @export
 * @interface BookedAncillaryIds
 */
export interface BookedAncillaryIds {
    'cfarContractId'?: ContractId;
}
export interface BookedRooms {
    'count': number;
    'roomInfo'?: RoomInfo;
}
export interface BoundingBox {
    'northEast': Coordinates;
    'southWest': Coordinates;
    'LocationDescriptor': LocationDescriptorEnum;
}


export interface BoundingCircle {
    'center': Coordinates;
    'radius': number;
    'LocationDescriptor': LocationDescriptorEnum;
}


/**
 * `taxes` - Tax breakdown in tenant currency.
 * `taxesLocalCurrency` - Tax breakdown in currency of the property (may differ from `taxes`) currency.
 * `fees` - Fee breakdown in tenant currency.
 * `feesLocalCurrency` - Fee breakdown in currency of the property (may differ from `fee`) currency.
 * @export
 * @interface Breakdown
 */
export interface Breakdown {
    'taxes': Taxes;
    'taxesLocalCurrency': Taxes;
    'fees': Fees;
    'feesLocalCurrency': Fees;
}
/**
 * policy result for hotel already in a canceled status
 * @export
 * @interface Canceled
 */
export interface Canceled {
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


/**
 * policy result for hotel that needs Customer Service action since a previous cancellation on it failed
 * @export
 * @interface CancellationFailure
 */
export interface CancellationFailure {
    'customerServiceCopy': Copy;
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


/**
 * @type CancellationPolicy
 * The cancellation policy
 * @export
 */
export type CancellationPolicy = { CancellationPolicy: 'Cfar' } & CfarPolicy | { CancellationPolicy: 'NonRefundable' } & NonRefundablePolicy | { CancellationPolicy: 'Refundable' } & RefundablePolicy;

export const CancellationPolicyEnum = {
    Cfar: 'Cfar',
    NonRefundable: 'NonRefundable',
    Refundable: 'Refundable'
} as const;

export type CancellationPolicyEnum = typeof CancellationPolicyEnum[keyof typeof CancellationPolicyEnum];


/**
 * Cancellation policy kind for a lodging
 * @export
 * @enum {string}
 */

export const CancellationPolicyKind = {
    FreeCancellation: 'FreeCancellation'
} as const;

export type CancellationPolicyKind = typeof CancellationPolicyKind[keyof typeof CancellationPolicyKind];


/**
 * @type CancellationPolicyV2
 * cancellation policy indicating whether the hotel is fully, partially or non-refundable at the time of booking
 * @export
 */
export type CancellationPolicyV2 = { CancellationPolicyV2: 'FullyRefundable' } & FullyRefundablePolicyV2 | { CancellationPolicyV2: 'NonRefundable' } & NonRefundablePolicyV2 | { CancellationPolicyV2: 'PartiallyRefundable' } & PartiallyRefundablePolicyV2 | { CancellationPolicyV2: 'Unknown' } & UnknownPolicyV2;

export const CancellationPolicyV2Enum = {
    FullyRefundable: 'FullyRefundable',
    NonRefundable: 'NonRefundable',
    PartiallyRefundable: 'PartiallyRefundable',
    Unknown: 'Unknown'
} as const;

export type CancellationPolicyV2Enum = typeof CancellationPolicyV2Enum[keyof typeof CancellationPolicyV2Enum];


/**
 * 

* `CaliforniaBill644` - California Senate Bill 644: https://hopper-jira.atlassian.net/wiki/spaces/H/pages/6525157446/Hotels+California+Bill+644+Tenant+Guidance
 * @export
 * @enum {string}
 */

export const CancellationReason = {
    CaliforniaBill644: 'CaliforniaBill644'
} as const;

export type CancellationReason = typeof CancellationReason[keyof typeof CancellationReason];


/**
 * `reasons` - Relevant cancellation reasons that apply at a lodging level
 * @export
 * @interface CancellationSummary
 */
export interface CancellationSummary {
    /**
     * Relevant cancellation reasons that apply at a lodging level
     * @type {Array<CancellationReason>}
     * @memberof CancellationSummary
     */
    'reasons': Array<CancellationReason>;
}
/**
 * Type of card used in the transaction
 * @export
 * @enum {string}
 */

export const CardType = {
    AmericanExpress: 'AmericanExpress',
    Dankort: 'Dankort',
    DinersClub: 'DinersClub',
    Discover: 'Discover',
    Jcb: 'Jcb',
    Maestro: 'Maestro',
    Master: 'Master',
    Unknown: 'Unknown',
    Visa: 'Visa'
} as const;

export type CardType = typeof CardType[keyof typeof CardType];


/**
 * `results` - list of autocomplete suggestions
 * @export
 * @interface CategorizedResponse
 */
export interface CategorizedResponse {
    'category': AutocompleteCategory;
    'label': string;
    /**
     * list of autocomplete suggestions
     * @type {Array<Suggestion>}
     * @memberof CategorizedResponse
     */
    'results': Array<Suggestion>;
}


/**
 * Middle ground pricing summary used in most pricing scenarios.Includes high level categories that the price is attributed but does not break down into specific line items with descriptions

 * `subTotal` - The Hopper, base sale rate of the hotel. This is the standard rate of the hotel that Hopper sells, without any modifiers that are non-standard to this hotel, ie. personal user discounts, or taxes/fees that are attributed separately
 * `taxesAndFees` - The total amount of taxes/fees that will be paid in the purchase, not attributed to any specific description/source.If they must be attributed separately use [[LineItemBreakdown]]
 * `discounts` - The total discount the user receives that drops the charge below the [[subTotal]]. This includes anything that reduces the price down from the normal price ie. temporary promotions. If they must be attributed separately use [[LineItemBreakdown]]
 * `total` - The final amount the user pays at checkout
 * @export
 * @interface CategorySummary
 */
export interface CategorySummary {
    'subTotal': Prices;
    'total': Prices;
    'LodgingPriceBreakdown': LodgingPriceBreakdownEnum;
    'taxesAndFees'?: Prices;
    'discounts'?: Prices;
}


/**
 * CFAR policy details from the order details. If None, CFAR was not purchased.
 * @export
 * @interface Cfar
 */
export interface Cfar {
    'contractId': ContractId;
    'price': Prices;
}
/**
 * @type CfarBrand
 * The brand of CFAR. Controls any brand-specific logic.
 * @export
 */
export type CfarBrand = { CfarBrand: 'Ancillary' } & Ancillary | { CfarBrand: 'Synthetic' } & Synthetic | { CfarBrand: 'SyntheticNegative' } & SyntheticNegative;

export const CfarBrandEnum = {
    Ancillary: 'Ancillary',
    Synthetic: 'Synthetic',
    SyntheticNegative: 'SyntheticNegative'
} as const;

export type CfarBrandEnum = typeof CfarBrandEnum[keyof typeof CfarBrandEnum];


/**
 * `cfarContractId` - Unique id of Contract
 * `exerciseExpiration` - The last instant at which the contract can be exercised
 * `coverageIncludesPremium` - If coverage includes cost of the premium. Optional for compatibility, default to false.
 * `coverage` - The coverage paid out upon exercise in currency
 * `coveragePercentage` - The coverage(to be paid out upon exercise) as a percentage of booked amount
 * `premium` - Cost paid for the contract
 * `isExercisable` - If the contract is able to be exercised
 * @export
 * @interface CfarContract
 */
export interface CfarContract {
    /**
     * Unique id of Contract
     * @type {string}
     * @memberof CfarContract
     */
    'cfarContractId'?: string;
    'HotelAncillary': HotelAncillaryEnum;
    /**
     * The last instant at which the contract can be exercised
     * @type {string}
     * @memberof CfarContract
     */
    'exerciseExpiration'?: string;
    /**
     * If coverage includes cost of the premium. Optional for compatibility, default to false.
     * @type {boolean}
     * @memberof CfarContract
     */
    'coverageIncludesPremium'?: boolean;
    'coverage'?: Prices;
    /**
     * The coverage(to be paid out upon exercise) as a percentage of booked amount
     * @type {number}
     * @memberof CfarContract
     */
    'coveragePercentage'?: number;
    'premium': Prices;
    /**
     * If the contract is able to be exercised
     * @type {boolean}
     * @memberof CfarContract
     */
    'isExercisable'?: boolean;
}


export interface CfarPolicy {
    'perNightRefund'?: Prices;
    'taxExclusiveRefund': Prices;
    'CancellationPolicy': CancellationPolicyEnum;
    'coveragePercentage': number;
    'bookingAmount': Prices;
    'refundAmount': Prices;
    'primaryText': string;
}


/**
 * @type CfarRateQuote
 * @export
 */
export type CfarRateQuote = { CfarRateQuote: 'Declined' } & CfarRateQuoteDeclined | { CfarRateQuote: 'Success' } & CfarRateQuoteSuccess;

export interface CfarRateQuoteDeclined {
    'trackingProperties': TrackingProperties;
    'CfarRateQuote': CfarRateQuoteEnum;
}


export const CfarRateQuoteEnum = {
    Declined: 'Declined',
    Success: 'Success'
} as const;

export type CfarRateQuoteEnum = typeof CfarRateQuoteEnum[keyof typeof CfarRateQuoteEnum];


/**
 * `expirationTs` - Expiration timestamp of the offer after which it is invalid. Same as exercise expiration timestamp.
 * `merchandisingPlacement` - Dictates where the offer should be placed - on the rooms list or as an ancillary.
 * `refundPremiumAtExercise` - Whether or not the coverage includes the premium and therefore should be refunded on exercise
 * `expirationInHotelTz` - Expiration in hotel timezone.
 * `brand` - The brand of CFAR. Controls any brand-specific logic.
 * `isRefundableRoom` - If this quote should apply to a Hopper Refundable Room policy. As of 2024-12-20, each room will only have one or zero total Hopper refundable room policies.
 * @export
 * @interface CfarRateQuoteSuccess
 */
export interface CfarRateQuoteSuccess {
    /**
     * Expiration timestamp of the offer after which it is invalid. Same as exercise expiration timestamp.
     * @type {string}
     * @memberof CfarRateQuoteSuccess
     */
    'expirationTs'?: string;
    'merchandisingPlacement'?: MerchandisingPlacement;
    /**
     * Whether or not the coverage includes the premium and therefore should be refunded on exercise
     * @type {boolean}
     * @memberof CfarRateQuoteSuccess
     */
    'refundPremiumAtExercise': boolean;
    'CfarRateQuote': CfarRateQuoteEnum;
    /**
     * Expiration in hotel timezone.
     * @type {string}
     * @memberof CfarRateQuoteSuccess
     */
    'expirationInHotelTz': string;
    'trackingProperties': TrackingProperties;
    'brand'?: CfarBrand;
    'coverageAmount': Prices;
    'premiumAmount': Prices;
    'id': string;
    'coveragePercentage': number;
    /**
     * If this quote should apply to a Hopper Refundable Room policy. As of 2024-12-20, each room will only have one or zero total Hopper refundable room policies.
     * @type {boolean}
     * @memberof CfarRateQuoteSuccess
     */
    'isRefundableRoom': boolean;
}


export interface CheckInInstructions {
    'checkOutTime'?: string;
    'minimumAge'?: number;
    'checkInTime'?: CheckInTime;
    'acceptedCards': Array<string>;
    'policies': Array<CheckInPolicy>;
}
/**
 * Added for temporary backwards compatibility in capone. Other tenants should use MinimumCheckInAgeNotMet.
 * @export
 * @interface CheckInMinimumAgeNotMet
 */
export interface CheckInMinimumAgeNotMet {
    'LodgingError': LodgingErrorEnum;
}


export interface CheckInPolicy {
    'title': string;
    'text': string;
}
/**
 * @type CheckInTime
 * @export
 */
export type CheckInTime = { CheckInTime: 'Anytime' } & Anytime | { CheckInTime: 'Restricted' } & Restricted;

export const CheckInTimeEnum = {
    Anytime: 'Anytime',
    Restricted: 'Restricted'
} as const;

export type CheckInTimeEnum = typeof CheckInTimeEnum[keyof typeof CheckInTimeEnum];


/**
 * Provider client is not defined
 * @export
 * @interface ClientNotDefined
 */
export interface ClientNotDefined {
    'LodgingError': LodgingErrorEnum;
}


/**
 * `listingContent` - Listing content info
 * `listingTerms` - Rules around the listing, for example the max occupancy
 * @export
 * @interface CondensedHomesListingDetails
 */
export interface CondensedHomesListingDetails {
    'listingContent': HomesListingContent;
    'listingTerms': HomesListingTerms;
}
/**
 * policy result for hotel that needs Customer Service action to be canceled
 * @export
 * @interface ContactCustomerService
 */
export interface ContactCustomerService {
    'customerServiceCopy': Copy;
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


export interface ContractId {
    'value': string;
}
export interface Coordinate {
    'lat': number;
    'lon': number;
    'LocationQuery': LocationQueryEnum;
}


export interface Coordinates {
    'lat': number;
    'lon': number;
}
export interface Copy {
    'importantInfo': Array<string>;
    'body': Array<string>;
    'informativeSection'?: InformativeSection;
    'disclaimer'?: string;
    'title': string;
}
export interface CorporateTravel {
    'policyCompliance': PolicyCompliance;
}
export interface Coverage {
    'amount': Prices;
    'coverage': number;
}
/**
 * `breakdown` - The granular Scranton credit details that composes TravelWalletCredit. The sum(breakdown) should equal TravelWalletCredit.amount
 * @export
 * @interface Credit
 */
export interface Credit {
    'amount': FiatAmount;
    /**
     * The granular Scranton credit details that composes TravelWalletCredit. The sum(breakdown) should equal TravelWalletCredit.amount
     * @type {Array<CreditDetail>}
     * @memberof Credit
     */
    'breakdown': Array<CreditDetail>;
    'TravelWallet': TravelWalletEnum;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * The granular Scranton credit detail

 * `description` - A direct user copy that is localized/specific to the tenant
 * @export
 * @interface CreditDetail
 */
export interface CreditDetail {
    /**
     * A direct user copy that is localized/specific to the tenant
     * @type {string}
     * @memberof CreditDetail
     */
    'description': string;
    'amount': FiatAmount;
}
/**
 * `until` must be later in time than `from`
 * @export
 * @interface DateRange
 */
export interface DateRange {
    /**
     * check-in date
     * @type {string}
     * @memberof DateRange
     */
    'from': string;
    /**
     * check-out date
     * @type {string}
     * @memberof DateRange
     */
    'until': string;
}
export interface Discount {
    'value': Prices;
    'description': string;
}
export interface DiscountAwarePrices {
    'priceWithUnmanagedDiscounts': Prices;
    'priceWithAllDiscounts': Prices;
    'priceWithNoDiscounts': Prices;
}
export interface DiscountHunting {
    'webPrice': Prices;
    'savingsAmount': Prices;
}
/**
 * `distanceInKm` - Distance expressed in kilometers
 * `distanceInMi` - Distance expressed in miles
 * @export
 * @interface Distance
 */
export interface Distance {
    /**
     * Distance expressed in kilometers
     * @type {number}
     * @memberof Distance
     */
    'distanceInKm': number;
    /**
     * Distance expressed in miles
     * @type {number}
     * @memberof Distance
     */
    'distanceInMi': number;
}
export interface DriverLicense {
    'country': string;
    'cityCode': string;
    'street': string;
    'postCode': string;
}
/**
 * `basePoints` - The number of base (non-promotion) points that will be earned for the lodging.
 * `promotionPoints` - A list of the promotions for which the lodging is eligible and the respective point values.
 * `totalPoints` - Total number of points that will be earned on the respective product.
 * @export
 * @interface EarnAmount
 */
export interface EarnAmount {
    /**
     * The number of base (non-promotion) points that will be earned for the lodging.
     * @type {number}
     * @memberof EarnAmount
     */
    'basePoints'?: number;
    /**
     * A list of the promotions for which the lodging is eligible and the respective point values.
     * @type {Array<EarnPromotionAmount>}
     * @memberof EarnAmount
     */
    'promotionPoints': Array<EarnPromotionAmount>;
    /**
     * Total number of points that will be earned on the respective product.
     * @type {number}
     * @memberof EarnAmount
     */
    'totalPoints'?: number;
}
/**
 * `promotionId` - A unique identifier for this promotion.
 * `numPoints` - The number of points that the user is earning on the promotion.
 * @export
 * @interface EarnPromotionAmount
 */
export interface EarnPromotionAmount {
    /**
     * A unique identifier for this promotion.
     * @type {string}
     * @memberof EarnPromotionAmount
     */
    'promotionId'?: string;
    /**
     * The number of points that the user is earning on the promotion.
     * @type {number}
     * @memberof EarnPromotionAmount
     */
    'numPoints': number;
}
/**
 * @type EffectiveRange
 * @export
 */
export type EffectiveRange = { EffectiveRange: 'Available' } & Available | { EffectiveRange: 'NotAvailable' } & NotAvailable;

export const EffectiveRangeEnum = {
    Available: 'Available',
    NotAvailable: 'NotAvailable'
} as const;

export type EffectiveRangeEnum = typeof EffectiveRangeEnum[keyof typeof EffectiveRangeEnum];


export interface Empty {
    'LocationQuery': LocationQueryEnum;
}


export interface ErrorCode {
    'code': string;
    'details'?: string;
}
export interface Failure {
    'errors': Array<ErrorCode>;
    'Response': ResponseEnum;
}


export interface Fees {
    'hotelFees'?: FiatPrice;
    'resortFees'?: FiatPrice;
    'cityTaxes'?: FiatPrice;
    'total'?: FiatPrice;
}
export interface FiatAmount {
    'currency': string;
    'amount': number;
    'PaymentAmount': PaymentAmountEnum;
}


/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export interface FiatPriceRange {
    'range': PriceRange;
    'currencyCode': string;
}
/**
 * `customerReservationId` - external identifier of the reservation
 * `reservationBookingId` - unique, hopper internal identifier of the reservation
 * `trackingProperties` - properties used for tracking and identifying the reservation
 * @export
 * @interface FinalizedLodging
 */
export interface FinalizedLodging {
    /**
     * external identifier of the reservation
     * @type {string}
     * @memberof FinalizedLodging
     */
    'customerReservationId': string;
    /**
     * unique, hopper internal identifier of the reservation
     * @type {string}
     * @memberof FinalizedLodging
     */
    'reservationBookingId': string;
    'trackingProperties': TrackingProperties;
}
/**
 * additional search request

 * `moreToken` - nextPageToken from AvailabilityResponse
 * `progressiveConfig` - number of lodging options to return
 * `lodgingCollection` - what lodging collection, if any, availability is being requested for
 * `excludeNonLuxuryLodgings` - Deprecated, use lodgingCollection
 * @export
 * @interface FollowUpSearch
 */
export interface FollowUpSearch {
    'lodgingCollection': LodgingCollection;
    /**
     * nextPageToken from AvailabilityResponse
     * @type {string}
     * @memberof FollowUpSearch
     */
    'moreToken': string;
    'progressiveConfig': ProgressiveConfig;
    /**
     * Deprecated, use lodgingCollection
     * @type {boolean}
     * @memberof FollowUpSearch
     */
    'excludeNonLuxuryLodgings': boolean;
    'AvailabilityRequest': AvailabilityRequestEnum;
}


export interface FrequentFlyerNumber {
    'value': string;
}
/**
 * A frequent guest number number is required for this booking. Another term is "hotel loyalty number".
 * @export
 * @interface FrequentGuestNumberRequired
 */
export interface FrequentGuestNumberRequired {
    'LodgingError': LodgingErrorEnum;
}


/**
 * policy result for hotel cancellation that results in a full refund
 * @export
 * @interface FullRefund
 */
export interface FullRefund {
    'cancelCopy': Copy;
    'cancelConfirmationCopy': Copy;
    'preparedPayment': string;
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


/**
 * Policy result for hotels that are refundable but already have a refund attached - complex scenario that for the time being will be handled by Customer Service agent to avoid over/under refund.
 * @export
 * @interface FullyRefundableComplex
 */
export interface FullyRefundableComplex {
    'customerServiceCopy': Copy;
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


/**
 * room is fully refundable
 * @export
 * @interface FullyRefundablePolicyV2
 */
export interface FullyRefundablePolicyV2 {
    'secondaryText'?: string;
    'effectiveRange': EffectiveRange;
    'CancellationPolicyV2': CancellationPolicyV2Enum;
    'primaryText': string;
    'cfarInfoBannerText'?: string;
}


export const Funnel = {
    Air: 'Air',
    Ground: 'Ground',
    Home: 'Home',
    Lodging: 'Lodging'
} as const;

export type Funnel = typeof Funnel[keyof typeof Funnel];


export const Gender = {
    F: 'F',
    M: 'M'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];


export interface GetHotelReservationRequest {
    'reservationBookingId': string;
}
export interface GoogleMapsApiKey {
    'key': string;
}
/**
 * Amount charged through Google Pay
 * @export
 * @interface GooglePay
 */
export interface GooglePay {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * `adults` - number of adults
 * `children` - ages of the children
 * `pets` - number of pets. 0 if no pets.
 * @export
 * @interface GuestsSelection
 */
export interface GuestsSelection {
    /**
     * number of adults
     * @type {number}
     * @memberof GuestsSelection
     */
    'adults': number;
    /**
     * ages of the children
     * @type {Array<number>}
     * @memberof GuestsSelection
     */
    'children': Array<number>;
    /**
     * number of pets. 0 if no pets.
     * @type {number}
     * @memberof GuestsSelection
     */
    'pets'?: number;
}
/**
 * `hasBreakfastIncluded` - True when this lodging have breakfast included
 * `hasPayLater` - True when this lodging have pay later rates
 * @export
 * @interface Highlights
 */
export interface Highlights {
    /**
     * True when this lodging have breakfast included
     * @type {boolean}
     * @memberof Highlights
     */
    'hasBreakfastIncluded'?: boolean;
    /**
     * True when this lodging have pay later rates
     * @type {boolean}
     * @memberof Highlights
     */
    'hasPayLater'?: boolean;
}
export interface HomesBathroom {
    'name': string;
    'description'?: string;
}
export interface HomesBedType {
    'name': string;
    'count': number;
}
export interface HomesBedroom {
    'name': string;
    'description'?: string;
    'bedTypes': Array<HomesBedType>;
}
/**
 * `listingLayout` - Layout of the property, such as number of bedrooms, bathrooms, etc.
 * `homesStarRating` - Star rating of the property [1, 5].
 * `homesUserRating` - User rating of the property [0.0, 100.0].
 * `amenities` - Amenities for the property, such as wifi, pool, etc.
 * @export
 * @interface HomesListingContent
 */
export interface HomesListingContent {
    'listingLayout': HomesListingLayout;
    /**
     * Star rating of the property [1, 5].
     * @type {number}
     * @memberof HomesListingContent
     */
    'homesStarRating'?: number;
    'homesUserRating'?: ListingUserRating;
    /**
     * Amenities for the property, such as wifi, pool, etc.
     * @type {Array<LodgingHomesAmenity>}
     * @memberof HomesListingContent
     */
    'amenities'?: Array<LodgingHomesAmenity>;
}
/**
 * Layout of the property, such as number of bedrooms, bathrooms, etc.
 * @export
 * @interface HomesListingLayout
 */
export interface HomesListingLayout {
    'bedrooms': Array<HomesBedroom>;
    'numberOfBathrooms': number;
    'numberOfBedrooms': number;
    'bathrooms': Array<HomesBathroom>;
    'numberOfBeds': number;
}
/**
 * `maxOccupancy` - The maximum number of guests allowed in the property.
 * @export
 * @interface HomesListingTerms
 */
export interface HomesListingTerms {
    /**
     * The maximum number of guests allowed in the property.
     * @type {number}
     * @memberof HomesListingTerms
     */
    'maxOccupancy': number;
}
/**
 * A closed set of categories to tag rates according to Hopper definitions. This is used to merchandise special rates to users. For example, displaying badges for mobile exclusive rates.

* `B2B` - B2B rates are exclusive rates that are only available to users in B2B tenants
* `CUG` - CUG (closed user group) rates are rates that are available to users who are signed in
* `Mobile` - Mobile rates are mobile exclusive rates that are available to users on the mobile app only
* `OpaquePackage` - OpaquePackage rates are rates that are meant to only be booked within the same transaction as another product
* `Package` - Package rates are rates that are available to users who have purchased another product
* `Public` - Public rates are rates that are available to all users
* `Unknown` - Unknown rates are rates that do not fit into any of the other categories
 * @export
 * @enum {string}
 */

export const HopperRateCategory = {
    B2B: 'B2B',
    CUG: 'CUG',
    Mobile: 'Mobile',
    OpaquePackage: 'OpaquePackage',
    Package: 'Package',
    Public: 'Public',
    Unknown: 'Unknown'
} as const;

export type HopperRateCategory = typeof HopperRateCategory[keyof typeof HopperRateCategory];


export interface Hotel {
    'productPricing': ProductPricing;
    'comparisonDifference'?: Amount;
    'ProductInfo': ProductInfoEnum;
}


/**
 * @type HotelAncillary
 * @export
 */
export type HotelAncillary = { HotelAncillary: 'CfarContract' } & CfarContract | { HotelAncillary: 'Insurance' } & Insurance;

export const HotelAncillaryEnum = {
    CfarContract: 'CfarContract',
    Insurance: 'Insurance'
} as const;

export type HotelAncillaryEnum = typeof HotelAncillaryEnum[keyof typeof HotelAncillaryEnum];


/**
 * @type HotelCancelScenario
 * @export
 */
export type HotelCancelScenario = { HotelCancelScenario: 'Canceled' } & Canceled | { HotelCancelScenario: 'CancellationFailure' } & CancellationFailure | { HotelCancelScenario: 'ContactCustomerService' } & ContactCustomerService | { HotelCancelScenario: 'FullRefund' } & FullRefund | { HotelCancelScenario: 'FullyRefundableComplex' } & FullyRefundableComplex | { HotelCancelScenario: 'NonRefundable' } & NonRefundable | { HotelCancelScenario: 'PartialRefund' } & PartialRefund | { HotelCancelScenario: 'PartiallyRefundableComplex' } & PartiallyRefundableComplex | { HotelCancelScenario: 'Pending' } & Pending;

export const HotelCancelScenarioEnum = {
    Canceled: 'Canceled',
    CancellationFailure: 'CancellationFailure',
    ContactCustomerService: 'ContactCustomerService',
    FullRefund: 'FullRefund',
    FullyRefundableComplex: 'FullyRefundableComplex',
    NonRefundable: 'NonRefundable',
    PartialRefund: 'PartialRefund',
    PartiallyRefundableComplex: 'PartiallyRefundableComplex',
    Pending: 'Pending'
} as const;

export type HotelCancelScenarioEnum = typeof HotelCancelScenarioEnum[keyof typeof HotelCancelScenarioEnum];


/**
 * @type HotelCancelScenarioResponse
 * @export
 */
export type HotelCancelScenarioResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & HotelCancelScenarioSuccess;

export interface HotelCancelScenarioSuccess {
    'value': HotelCancelScenario;
    'Response': ResponseEnum;
}


export interface HotelCancellationPolicyRequest {
    'reservationId': string;
}
export interface HotelCancellationRequest {
    'reservationId': string;
    'cancelScenario': HotelCancelScenario;
}
export interface HotelCancellationResult {
    'success': boolean;
}
/**
 * @type HotelCancellationResultResponse
 * @export
 */
export type HotelCancellationResultResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & HotelCancellationResultSuccess;

export interface HotelCancellationResultSuccess {
    'value': HotelCancellationResult;
    'Response': ResponseEnum;
}


/**
 * @type HotelConfirmationCode
 * hotel confirmation code provided by the hotel post-booking
 * @export
 */
export type HotelConfirmationCode = { HotelConfirmationCode: 'HotelConfirmationConfirmed' } & HotelConfirmationConfirmed | { HotelConfirmationCode: 'HotelConfirmationPending' } & HotelConfirmationPending | { HotelConfirmationCode: 'HotelConfirmationUnavailable' } & HotelConfirmationUnavailable;

export const HotelConfirmationCodeEnum = {
    HotelConfirmationConfirmed: 'HotelConfirmationConfirmed',
    HotelConfirmationPending: 'HotelConfirmationPending',
    HotelConfirmationUnavailable: 'HotelConfirmationUnavailable'
} as const;

export type HotelConfirmationCodeEnum = typeof HotelConfirmationCodeEnum[keyof typeof HotelConfirmationCodeEnum];


/**
 * Hotel confirmation code provided directly from the hotel. Generally available only after booking is confirmed and < 2 weeks before check-in.

 * `rateOwner` - Rate provider for the hotel. Used primarily for tracking.
 * @export
 * @interface HotelConfirmationConfirmed
 */
export interface HotelConfirmationConfirmed {
    'confirmationCode': string;
    /**
     * Rate provider for the hotel. Used primarily for tracking.
     * @type {string}
     * @memberof HotelConfirmationConfirmed
     */
    'rateOwner': string;
    'HotelConfirmationCode': HotelConfirmationCodeEnum;
}


/**
 * Hotel confirmation code is pending. We are expected to make a call to Hamburg to receive this at the expected date.

 * `expectedDate` - Expected date to receive the confirmation code.
 * `rateOwner` - Rate provider for the hotel. Used primarily for tracking
 * @export
 * @interface HotelConfirmationPending
 */
export interface HotelConfirmationPending {
    /**
     * Expected date to receive the confirmation code.
     * @type {string}
     * @memberof HotelConfirmationPending
     */
    'expectedDate': string;
    /**
     * Rate provider for the hotel. Used primarily for tracking
     * @type {string}
     * @memberof HotelConfirmationPending
     */
    'rateOwner': string;
    'HotelConfirmationCode': HotelConfirmationCodeEnum;
}


/**
 * Hotel confirmation code is unavailable, generally due it not being available from the provider api.

 * `rateOwner` - Rate provider for the hotel. Used primarily for tracking
 * `reason` - Non-user facing reason for the code being unavailable. Used for debugging and tracking.
 * @export
 * @interface HotelConfirmationUnavailable
 */
export interface HotelConfirmationUnavailable {
    /**
     * Rate provider for the hotel. Used primarily for tracking
     * @type {string}
     * @memberof HotelConfirmationUnavailable
     */
    'rateOwner': string;
    /**
     * Non-user facing reason for the code being unavailable. Used for debugging and tracking.
     * @type {string}
     * @memberof HotelConfirmationUnavailable
     */
    'reason'?: string;
    'HotelConfirmationCode': HotelConfirmationCodeEnum;
}


/**
 * Struct that keeps tracks of information throughout a hotel funnel session.

 * `sessionId` - The session id of the hotel funnel session.
 * `stageId` - The stage id used throughout the processing of this response.
 * `parentStageId` - The stage id of the preceding stage for this funnel session, or empty if this is the root of the stage session.
 * `stageName` - The name of the stage that this session completed.
 * @export
 * @interface HotelFunnelSession
 */
export interface HotelFunnelSession {
    /**
     * The session id of the hotel funnel session.
     * @type {string}
     * @memberof HotelFunnelSession
     */
    'sessionId': string;
    /**
     * The stage id used throughout the processing of this response.
     * @type {string}
     * @memberof HotelFunnelSession
     */
    'stageId': string;
    /**
     * The stage id of the preceding stage for this funnel session, or empty if this is the root of the stage session.
     * @type {string}
     * @memberof HotelFunnelSession
     */
    'parentStageId'?: string;
    /**
     * The name of the stage that this session completed.
     * @type {string}
     * @memberof HotelFunnelSession
     */
    'stageName': string;
}
/**
 * Represents a hotel booking itinerary

 * `productTotal` - TripTotal within Hotel Reservation (includes amount owed at the hotel) plus ancillary premiums
 * `earnAmount` - EarnAmount for the booking.
 * `cfar` - CFAR policy details from the order details. If None, CFAR was not purchased.
 * `paymentTotal` - Sum of all payments in PaymentBreakdown
 * `reservation` - Hotel Reservation Info
 * `paymentBreakdown` - Breakdown of all the payments used for purchase
 * @export
 * @interface HotelItinerary
 */
export interface HotelItinerary {
    'ancillaries': Array<HotelAncillary>;
    'productTotal': Prices;
    'earnAmount'?: EarnAmount;
    'cfar'?: Cfar;
    'paymentTotal': Prices;
    'reservation': Reservation;
    'paymentBreakdown'?: PaymentBreakdown;
}
export interface HotelItineraryRequest {
    'states': Array<HotelItineraryState>;
    'referenceDateTime': string;
}
export interface HotelItineraryResponse {
    'itineraries': { [key: string]: Array<HotelItinerarySummary>; };
}
export const HotelItineraryState = {
    Canceled: 'Canceled',
    Future: 'Future',
    Invalid: 'Invalid',
    Past: 'Past',
    Present: 'Present'
} as const;

export type HotelItineraryState = typeof HotelItineraryState[keyof typeof HotelItineraryState];


/**
 * minimized model for representing a hotel booking. Only contains key properties of the booking

 * `reservationId` - external identifier of the reservation
 * `reservationBookingId` - unique internal identifier of the reservation
 * @export
 * @interface HotelItinerarySummary
 */
export interface HotelItinerarySummary {
    'state': ReservationState;
    /**
     * external identifier of the reservation
     * @type {string}
     * @memberof HotelItinerarySummary
     */
    'reservationId': string;
    'ancillaries': Array<HotelAncillary>;
    /**
     * unique internal identifier of the reservation
     * @type {string}
     * @memberof HotelItinerarySummary
     */
    'reservationBookingId': string;
    'bookingCreationDate'?: string;
    'lodgingSummary'?: LodgingSummary;
    'checkOutDate': string;
    'checkInDate': string;
}
export interface HotelLoyaltyNumber {
    'value': string;
}
export interface HotelMarket {
    'code': string;
    'Id': PlaceIdEnum;
}


/**
 * lodging star rating (1-5 or not available)
 * @export
 * @enum {string}
 */

export const HotelStarRating = {
    Five: 'Five',
    Four: 'Four',
    NotAvailable: 'NotAvailable',
    One: 'One',
    Three: 'Three',
    Two: 'Two'
} as const;

export type HotelStarRating = typeof HotelStarRating[keyof typeof HotelStarRating];


export interface InformativeSection {
    'title': string;
    'body': Array<string>;
}
/**
 * initial response with available rooms and best offer

 * `nextPageToken` - token to get next page list of lodging options
 * `bestOverallOffer` - deprecated (use offers) - travel wallet offer if any
 * `totalPropertyCount` - total number of possible lodging options
 * `offers` - Wallet Response per lodging product
 * `dates` - check-in to check-out dates
 * `updatePageToken` - Token to get thorough availability results when using the fast availability strategy.
 * `hotelFunnelSession` - Hotel Funnel Session information
 * `parisBestOverallOffer` - deprecated (use offers) - travel wallet offer if any
 * `lodgings` - list of possible lodging options
 * `centroid` - centroid calculated from the coordinates of lodgings returned. Used to position the map.
 * `offerApplicabilityResponse` - deprecated (use offers) - TravelWalletOffer mapped to ActiveOfferId
 * @export
 * @interface Initial
 */
export interface Initial {
    'AvailabilityResponse': AvailabilityResponseEnum;
    /**
     * token to get next page list of lodging options
     * @type {string}
     * @memberof Initial
     */
    'nextPageToken'?: string;
    'bestOverallOffer'?: TravelWalletOffer;
    /**
     * total number of possible lodging options
     * @type {number}
     * @memberof Initial
     */
    'totalPropertyCount'?: number;
    'offers'?: WalletOfferApplicabilityResponse;
    'dates': DateRange;
    /**
     * Token to get thorough availability results when using the fast availability strategy.
     * @type {string}
     * @memberof Initial
     */
    'updatePageToken'?: string;
    'hotelFunnelSession'?: HotelFunnelSession;
    'parisBestOverallOffer'?: TravelWalletOffer;
    'trackingPropertiesV2': TrackingProperties;
    /**
     * list of possible lodging options
     * @type {Array<Lodging>}
     * @memberof Initial
     */
    'lodgings': Array<Lodging>;
    'centroid'?: Coordinates;
    'offerApplicabilityResponse'?: OfferApplicabilityResponse;
}


/**
 * initial search request

 * `lodgingCollection` - what lodging collection, if any, availability is being requested for
 * `searchRefinementOptions` - Filters for availability search to be forwarded to LSA
 * `progressiveConfig` - number of lodging options to return
 * `stayDates` - check-in to check-out dates
 * `excludeNonLuxuryLodgings` - Deprecated, use lodgingCollection
 * `excludeCUGRates` - To enable front-end fencing, this flag is used to exclude CUG rates from the search results
 * `availabilityStrategy` - Availability Strategy, the default is to use Thorough
 * `guests` - number of adults and ages of the children
 * `rooms` - number of rooms (default = 1)
 * `forcePublicRates` - Force public rates in order to get a comparable price
 * `platform` - mobile or desktop user
 * `lodgingSelection` - type of lodging search: Place, LodgingIds, Location, Market
 * `rateFencingTokenOverride` - Override the rate fencing token used for determining applicable rates
 * @export
 * @interface InitialSearch
 */
export interface InitialSearch {
    'lodgingCollection': LodgingCollection;
    'searchRefinementOptions'?: SearchRefinementOptions;
    'progressiveConfig': ProgressiveConfig;
    'stayDates': DateRange;
    /**
     * Deprecated, use lodgingCollection
     * @type {boolean}
     * @memberof InitialSearch
     */
    'excludeNonLuxuryLodgings': boolean;
    /**
     * To enable front-end fencing, this flag is used to exclude CUG rates from the search results
     * @type {boolean}
     * @memberof InitialSearch
     */
    'excludeCUGRates'?: boolean;
    'availabilityStrategy'?: AvailabilityStrategy;
    'guests': GuestsSelection;
    'rooms': RoomsSelection;
    'AvailabilityRequest': AvailabilityRequestEnum;
    /**
     * Force public rates in order to get a comparable price
     * @type {boolean}
     * @memberof InitialSearch
     */
    'forcePublicRates'?: boolean;
    'platform': Platform;
    'lodgingSelection': LodgingSelection;
    'rateFencingTokenOverride'?: OpaqueToken;
}


export interface Insurance {
    'premium': Prices;
    'finePrintUrl'?: string;
    'HotelAncillary': HotelAncillaryEnum;
}


/**
 * The quote provided is invalid
 * @export
 * @interface InvalidQuote
 */
export interface InvalidQuote {
    'LodgingError': LodgingErrorEnum;
}


export interface Label {
    'l': string;
    'LocationQuery': LocationQueryEnum;
}


/**
 * The reservation is no longer possible as the room is no longer available
 * @export
 * @interface LackOfInventory
 */
export interface LackOfInventory {
    'LodgingError': LodgingErrorEnum;
}


export interface LfarOffer {
    'premium': Premium;
    'coverage': Coverage;
    'brand': OpenEnum;
}


/**
 * Most detailed pricing summary, breaks down pricing into its smallest atomic units, mimicking what the financial ledger might look like for the purchase

 * `subTotal` - The Hopper, base sale rate of the hotel. This is the standard rate of the hotel that Hopper sells, without any modifiers that are non-standard to this hotel,ie. personal user discounts, or taxes/fees that are attributed separately
 * `taxAndFeeLineItems` - The taxes/fees that will be paid in the purchase, not attributed to any specific description/source.If they must be attributed separately use [[LineItemBreakdown]]
 * `discountLineItems` - The discounts the user receives that drops the charge below the [[subTotal]]. This includes anything that reduces the price down from the normal price ie. temporary promotions.
 * `total` - The final amount the user pays at checkout
 * @export
 * @interface LineItemBreakdown
 */
export interface LineItemBreakdown {
    'subTotal': Prices;
    /**
     * The discounts the user receives that drops the charge below the [[subTotal]]. This includes anything that reduces the price down from the normal price ie. temporary promotions.
     * @type {{ [key: string]: Prices; }}
     * @memberof LineItemBreakdown
     */
    'taxAndFeeLineItems': { [key: string]: Prices; };
    'total': Prices;
    'LodgingPriceBreakdown': LodgingPriceBreakdownEnum;
    /**
     * The discounts the user receives that drops the charge below the [[subTotal]]. This includes anything that reduces the price down from the normal price ie. temporary promotions.
     * @type {{ [key: string]: Prices; }}
     * @memberof LineItemBreakdown
     */
    'discountLineItems'?: { [key: string]: Prices; };
}


/**
 * Homes user rating value should be within range [0.0, 100.0]
 * @export
 * @interface ListingUserRating
 */
export interface ListingUserRating {
    /**
     * normalized rating value should be within range [0, 1]
     * @type {number}
     * @memberof ListingUserRating
     */
    'score': number;
    /**
     * Number of user reviews for the property.
     * @type {number}
     * @memberof ListingUserRating
     */
    'numberOfReviews': number;
}
/**
 * lodging search by location
 * @export
 * @interface Location
 */
export interface Location {
    'descriptor': LocationDescriptor;
    'center'?: Coordinates;
    'LodgingSelection': LodgingSelectionEnum;
}


/**
 * @type LocationDescriptor
 * @export
 */
export type LocationDescriptor = { LocationDescriptor: 'BoundingBox' } & BoundingBox | { LocationDescriptor: 'BoundingCircle' } & BoundingCircle;

export const LocationDescriptorEnum = {
    BoundingBox: 'BoundingBox',
    BoundingCircle: 'BoundingCircle'
} as const;

export type LocationDescriptorEnum = typeof LocationDescriptorEnum[keyof typeof LocationDescriptorEnum];


/**
 * @type LocationQuery
 * query by name, coordinates or featured markets
 * @export
 */
export type LocationQuery = { LocationQuery: 'Coordinate' } & Coordinate | { LocationQuery: 'Empty' } & Empty | { LocationQuery: 'Label' } & Label | { LocationQuery: 'LodgingFeaturedMarkets' } & LodgingFeaturedMarkets;

export const LocationQueryEnum = {
    Coordinate: 'Coordinate',
    Empty: 'Empty',
    Label: 'Label',
    LodgingFeaturedMarkets: 'LodgingFeaturedMarkets'
} as const;

export type LocationQueryEnum = typeof LocationQueryEnum[keyof typeof LocationQueryEnum];


/**
 * `highlights` - Highlights and other information about the lodging
 * `stayType` - The type of the lodging, e.g. Hotels, Homes. Default to Hotel if not provided.
 * `nthNightPromotion` - Nth Night Promotion for Luxury Collection Premier Lodgings
 * `price` - price of lodging
 * `bestOfferThisLodging` - Legacy offer, use bestOffer instead.
 * `earnAmount` - EarnAmount for the hotel.
 * `hasCorporateRates` - True if one of the rate is corporate
 * `loyaltyProgramCode` - Applicable loyalty program for lodging
 * `distanceFromCenter` - Distance between the search and the hotel location
 * `homesListingDetails` - Details about the homes listing. Only available for homes.
 * `lodging` - information about the lodging
 * `isSponsored` - Is this a sponsored listing
 * `bestOffer` - Best WalletOffer for this lodging
 * @export
 * @interface Lodging
 */
export interface Lodging {
    'lodgingCollection': LodgingCollection;
    'highlights'?: Highlights;
    'stayType'?: StayType;
    'minNightOfStay'?: number;
    'nthNightPromotion'?: NthNightPromotion;
    'lastViewed'?: string;
    'isPreferred': boolean;
    'description': string;
    'price'?: LodgingPrice;
    'bestOfferThisLodging'?: TravelWalletOffer;
    'earnAmount'?: EarnAmount;
    /**
     * True if one of the rate is corporate
     * @type {boolean}
     * @memberof Lodging
     */
    'hasCorporateRates'?: boolean;
    /**
     * Applicable loyalty program for lodging
     * @type {string}
     * @memberof Lodging
     */
    'loyaltyProgramCode'?: string;
    'isLuxuryCollection': boolean;
    'distanceFromCenter'?: Distance;
    'trackingPropertiesV2': TrackingProperties;
    'homesListingDetails'?: CondensedHomesListingDetails;
    'available'?: boolean;
    'lodging': LodgingData;
    /**
     * Is this a sponsored listing
     * @type {boolean}
     * @memberof Lodging
     */
    'isSponsored'?: boolean;
    'isFreeCancel': boolean;
    'bestPromotionThisLodging'?: LodgingPromotion;
    'bestOffer'?: TravelWalletOffer;
}


/**
 * @type LodgingAddress
 * lodging address
 * @export
 */
export type LodgingAddress = { LodgingAddress: 'Exact' } & LodgingAddressExact | { LodgingAddress: 'Obfuscated' } & LodgingAddressObfuscated;

export const LodgingAddressEnum = {
    Exact: 'Exact',
    Obfuscated: 'Obfuscated'
} as const;

export type LodgingAddressEnum = typeof LodgingAddressEnum[keyof typeof LodgingAddressEnum];


export interface LodgingAddressExact {
    'line1': string;
    'LodgingAddress': LodgingAddressEnum;
}


export interface LodgingAddressObfuscated {
    'city': string;
    'stateOrProvince': StateOrProvince;
    'LodgingAddress': LodgingAddressEnum;
}


/**
 * what lodging collection, if any, this reservation belongs to
 * @export
 * @enum {string}
 */

export const LodgingCollection = {
    Lifestyle: 'Lifestyle',
    NoCollection: 'NoCollection',
    Premier: 'Premier'
} as const;

export type LodgingCollection = typeof LodgingCollection[keyof typeof LodgingCollection];


export interface LodgingComparePrice {
    'source': string;
    'nightlyPrice': Prices;
}
/**
 * `city` - lodging city
 * `name` - lodging name
 * `location` - exact or approximate coordinates location of lodging
 * `state` - lodging state or province
 * `description` - lodging description
 * `checkInInstructions` - Check in instructions (check in and check out times)
 * `score` - lodging score (0-1)
 * `country` - lodging country
 * `metadata_provider` - provider supplying lodging's metadata
 * `amenities` - amenities with additional details (if any)
 * `tripAdvisorReviews` - trip advisor reviews (if any)
 * `media` - media assets of the lodging
 * `address` - lodging address
 * `chain` - lodging chain (if any). Not localized, or for display.
 * `smsPhone` - sms phone number (if any)
 * `phone` - phone number (if any)
 * @export
 * @interface LodgingData
 */
export interface LodgingData {
    /**
     * lodging city
     * @type {string}
     * @memberof LodgingData
     */
    'city': string;
    /**
     * lodging name
     * @type {string}
     * @memberof LodgingData
     */
    'name': string;
    'location': LodgingLocation;
    'state': StateOrProvince;
    /**
     * lodging description
     * @type {string}
     * @memberof LodgingData
     */
    'description': string;
    'checkInInstructions'?: CheckInInstructions;
    /**
     * normalized rating value should be within range [0, 1]
     * @type {number}
     * @memberof LodgingData
     */
    'score': number;
    /**
     * 2 character country code
     * @type {string}
     * @memberof LodgingData
     */
    'country': string;
    'id': string;
    /**
     * provider supplying lodging's metadata
     * @type {string}
     * @memberof LodgingData
     */
    'metadata_provider': string;
    /**
     * amenities with additional details (if any)
     * @type {Array<AmenityStatus>}
     * @memberof LodgingData
     */
    'amenities': Array<AmenityStatus>;
    'starRating': HotelStarRating;
    'tripAdvisorReviews'?: TripAdvisorReviews;
    /**
     * media assets of the lodging
     * @type {Array<LodgingMediaAsset>}
     * @memberof LodgingData
     */
    'media': Array<LodgingMediaAsset>;
    'address': LodgingAddress;
    'corporateTravel'?: AvailabilityLodgingDataCorporateTravel;
    /**
     * lodging chain (if any). Not localized, or for display.
     * @type {string}
     * @memberof LodgingData
     */
    'chain'?: string;
    /**
     * sms phone number (if any)
     * @type {string}
     * @memberof LodgingData
     */
    'smsPhone'?: string;
    /**
     * phone number (if any)
     * @type {string}
     * @memberof LodgingData
     */
    'phone'?: string;
}


/**
 * @type LodgingError
 * @export
 */
export type LodgingError = { LodgingError: 'CheckInMinimumAgeNotMet' } & CheckInMinimumAgeNotMet | { LodgingError: 'ClientNotDefined' } & ClientNotDefined | { LodgingError: 'FrequentGuestNumberRequired' } & FrequentGuestNumberRequired | { LodgingError: 'InvalidQuote' } & InvalidQuote | { LodgingError: 'LackOfInventory' } & LackOfInventory | { LodgingError: 'LodgingErrorCode' } & LodgingErrorCode | { LodgingError: 'MinimumCheckInAgeNotMet' } & MinimumCheckInAgeNotMet | { LodgingError: 'OfferNotFound' } & OfferNotFound | { LodgingError: 'PaymentFailed' } & PaymentFailed | { LodgingError: 'ProductNotFound' } & ProductNotFound | { LodgingError: 'ProviderNotDefined' } & ProviderNotDefined | { LodgingError: 'QuoteExpired' } & QuoteExpired | { LodgingError: 'RateNotAvailable' } & RateNotAvailable | { LodgingError: 'ServiceError' } & ServiceError | { LodgingError: 'Unavailable' } & Unavailable | { LodgingError: 'Unspecified' } & Unspecified;

export interface LodgingErrorCode {
    'code': string;
    'message'?: string;
    'LodgingError': LodgingErrorEnum;
}


export const LodgingErrorEnum = {
    CheckInMinimumAgeNotMet: 'CheckInMinimumAgeNotMet',
    ClientNotDefined: 'ClientNotDefined',
    FrequentGuestNumberRequired: 'FrequentGuestNumberRequired',
    InvalidQuote: 'InvalidQuote',
    LackOfInventory: 'LackOfInventory',
    LodgingErrorCode: 'LodgingErrorCode',
    MinimumCheckInAgeNotMet: 'MinimumCheckInAgeNotMet',
    OfferNotFound: 'OfferNotFound',
    PaymentFailed: 'PaymentFailed',
    ProductNotFound: 'ProductNotFound',
    ProviderNotDefined: 'ProviderNotDefined',
    QuoteExpired: 'QuoteExpired',
    RateNotAvailable: 'RateNotAvailable',
    ServiceError: 'ServiceError',
    Unavailable: 'Unavailable',
    Unspecified: 'Unspecified'
} as const;

export type LodgingErrorEnum = typeof LodgingErrorEnum[keyof typeof LodgingErrorEnum];


/**
 * Deprecated. Query type no longer supported in lodging Autocomplete service.
 * @export
 * @interface LodgingFeaturedMarkets
 */
export interface LodgingFeaturedMarkets {
    'LocationQuery': LocationQueryEnum;
}


export interface LodgingHomesAmenity {
    'kind': LodgingHomesAmenityKind;
    'displayName': string;
}


export const LodgingHomesAmenityKind = {
    Accessibility: 'Accessibility',
    AccessibleBathroom: 'AccessibleBathroom',
    AccessibleFacilities: 'AccessibleFacilities',
    AirConditioning: 'AirConditioning',
    AllergyFriendly: 'AllergyFriendly',
    BarInBuilding: 'BarInBuilding',
    BarbecueGrill: 'BarbecueGrill',
    Bathtub: 'Bathtub',
    BeachFront: 'BeachFront',
    BeachView: 'BeachView',
    BedLinens: 'BedLinens',
    Bicycle: 'Bicycle',
    BoardGames: 'BoardGames',
    Cable: 'Cable',
    CarbonMonoxideAlarm: 'CarbonMonoxideAlarm',
    CeilingFan: 'CeilingFan',
    CityView: 'CityView',
    CleaningProducts: 'CleaningProducts',
    Coffee: 'Coffee',
    CoffeeMaker: 'CoffeeMaker',
    CoffeeTea: 'CoffeeTea',
    ConvenientCheckInOut: 'ConvenientCheckInOut',
    CookingBasics: 'CookingBasics',
    Crib: 'Crib',
    DedicatedWorkspace: 'DedicatedWorkspace',
    DiningTable: 'DiningTable',
    DishesAndSilverware: 'DishesAndSilverware',
    Dishwasher: 'Dishwasher',
    DoormanEntry: 'DoormanEntry',
    Dryer: 'Dryer',
    Elevator: 'Elevator',
    Entertainment: 'Entertainment',
    Essentials: 'Essentials',
    EvCharger: 'EvCharger',
    ExtraPillowsAndBlankets: 'ExtraPillowsAndBlankets',
    FireExtinguisher: 'FireExtinguisher',
    FirePit: 'FirePit',
    Fireplace: 'Fireplace',
    FirstAidKit: 'FirstAidKit',
    FitnessCenter: 'FitnessCenter',
    FreeParking: 'FreeParking',
    Freezer: 'Freezer',
    FrontDesk: 'FrontDesk',
    GamingConsole: 'GamingConsole',
    GardenOrBackyard: 'GardenOrBackyard',
    Gym: 'Gym',
    HairDryer: 'HairDryer',
    Hangers: 'Hangers',
    Hdtv: 'Hdtv',
    Heating: 'Heating',
    HighChair: 'HighChair',
    HotTub: 'HotTub',
    HotWater: 'HotWater',
    HotWaterKettle: 'HotWaterKettle',
    Housekeeping: 'Housekeeping',
    InternetAccess: 'InternetAccess',
    Iron: 'Iron',
    Kayak: 'Kayak',
    KidFriendly: 'KidFriendly',
    Kitchen: 'Kitchen',
    Kitchenette: 'Kitchenette',
    Laundry: 'Laundry',
    MealAvailable: 'MealAvailable',
    Microwave: 'Microwave',
    MountainView: 'MountainView',
    NatureView: 'NatureView',
    OnDemandHousekeeping: 'OnDemandHousekeeping',
    OutdoorSeating: 'OutdoorSeating',
    OutdoorSpace: 'OutdoorSpace',
    Oven: 'Oven',
    PaidParking: 'PaidParking',
    Parking: 'Parking',
    PatioOrBalcony: 'PatioOrBalcony',
    PetFriendly: 'PetFriendly',
    Piano: 'Piano',
    PingPongTable: 'PingPongTable',
    Pool: 'Pool',
    PoolTable: 'PoolTable',
    PrivateEntrance: 'PrivateEntrance',
    PropertyView: 'PropertyView',
    Refrigerator: 'Refrigerator',
    RestaurantInBuilding: 'RestaurantInBuilding',
    Sauna: 'Sauna',
    SecureEntry: 'SecureEntry',
    SecureStorage: 'SecureStorage',
    SecuritySystem: 'SecuritySystem',
    Shampoo: 'Shampoo',
    SkiInSkiOut: 'SkiInSkiOut',
    SmokeAlarm: 'SmokeAlarm',
    SmokingAllowed: 'SmokingAllowed',
    SoundSystem: 'SoundSystem',
    Stove: 'Stove',
    StreetParking: 'StreetParking',
    Toaster: 'Toaster',
    Unrecognized: 'Unrecognized',
    Unspecified: 'Unspecified',
    WardrobeOrCloset: 'WardrobeOrCloset',
    Washer: 'Washer',
    WaterView: 'WaterView',
    Waterfront: 'Waterfront',
    Wifi: 'Wifi'
} as const;

export type LodgingHomesAmenityKind = typeof LodgingHomesAmenityKind[keyof typeof LodgingHomesAmenityKind];


/**
 * lodging search by lodging id
 * @export
 * @interface LodgingIds
 */
export interface LodgingIds {
    'lodgingIds': Array<string>;
    'preserveOrder'?: boolean;
    'LodgingSelection': LodgingSelectionEnum;
}


/**
 * @type LodgingLocation
 * exact or approximate coordinates location of lodging
 * @export
 */
export type LodgingLocation = { LodgingLocation: 'Approximate' } & LodgingLocationApproximate | { LodgingLocation: 'Exact' } & LodgingLocationExact;

export interface LodgingLocationApproximate {
    'coordinates': Coordinates;
    'LodgingLocation': LodgingLocationEnum;
}


export const LodgingLocationEnum = {
    Approximate: 'Approximate',
    Exact: 'Exact'
} as const;

export type LodgingLocationEnum = typeof LodgingLocationEnum[keyof typeof LodgingLocationEnum];


export interface LodgingLocationExact {
    'coordinates': Coordinates;
    'placeTypes': Array<PlaceType>;
    'LodgingLocation': LodgingLocationEnum;
}


/**
 * @type LodgingMediaAsset
 * @export
 */
export type LodgingMediaAsset = { LodgingMediaAsset: 'NonResizableImage' } & NonResizableImage | { LodgingMediaAsset: 'ResizableImage' } & ResizableImage | { LodgingMediaAsset: 'Video' } & Video;

export const LodgingMediaAssetEnum = {
    NonResizableImage: 'NonResizableImage',
    ResizableImage: 'ResizableImage',
    Video: 'Video'
} as const;

export type LodgingMediaAssetEnum = typeof LodgingMediaAssetEnum[keyof typeof LodgingMediaAssetEnum];


/**
 * `displayTaxesAndFeesIncluded` - Display total price including taxes and fees in the UI if true.
 * `tripTotal` - trip total price includes what is paid at the property
 * `breakdown` - Breakdown of payment that occurs as part of the transaction
 * `payAtHotelBreakdown` - Breakdown of payment that the user needs to pay outside of the Hopper transaction
 * `roomPaymentSchedule` - Display if the current lodging is a pay later or pay now. Pay later rates will indicate on payAtHotelBreakdown.
 * `mealPlan` - Type of meal plan included in the rate
 * `hopperRateCategory` - HopperRateCategory is a closed set of categories to tag rates according to Hopper definitions.
 * `nightlyDiscountAwareTaxesAndFeesIncluded` - Discount aware nightly price including taxes and fees.Use this field instead of [[nightlyDiscountAware]] when [[displayTaxesAndFeesIncludedNightlyPrice]] is true
 * `nightlyPriceTaxesAndFeesIncluded` - Nightly price including taxes and fees. Use this field instead of [[nightlyPrice]] when [[displayTaxesAndFeesIncludedNightlyPrice]] is true
 * `totalDiscountAwareTaxesAndFeesIncluded` - Discount aware total price including taxes and fees.Use this field instead of [[totalDiscountAware]] when [[displayTaxesAndFeesIncludedNightlyPrice]] is true
 * `displayTaxesAndFeesIncludedNightlyPrice` - Display nightly price including taxes and fees in the UI if true.
 * @export
 * @interface LodgingPrice
 */
export interface LodgingPrice {
    /**
     * Display total price including taxes and fees in the UI if true.
     * @type {boolean}
     * @memberof LodgingPrice
     */
    'displayTaxesAndFeesIncluded'?: boolean;
    'tripTotal'?: Prices;
    'breakdown': LodgingPriceBreakdown;
    'nightlyDiscountAware': DiscountAwarePrices;
    'payAtHotelBreakdown'?: LodgingPriceBreakdown;
    'roomPaymentSchedule'?: RoomPaymentSchedule;
    'mealPlan'?: MealPlan;
    'totalPrice': Prices;
    'hopperRateCategory': HopperRateCategory;
    'nightlyDiscountAwareTaxesAndFeesIncluded'?: DiscountAwarePrices;
    'nightlyPriceTaxesAndFeesIncluded'?: Prices;
    'totalDiscountAware': DiscountAwarePrices;
    /**
     * Encrypted, opaque request used to shop rooms for the same available lodging
     * @type {any}
     * @memberof LodgingPrice
     */
    'opaqueShopRequest': any;
    'trackingPropertiesV2': TrackingProperties;
    'nightlyPrice': Prices;
    'providerName': string;
    'totalDiscountAwareTaxesAndFeesIncluded'?: DiscountAwarePrices;
    /**
     * Display nightly price including taxes and fees in the UI if true.
     * @type {boolean}
     * @memberof LodgingPrice
     */
    'displayTaxesAndFeesIncludedNightlyPrice'?: boolean;
    'comparePrices': Array<LodgingComparePrice>;
    'discountHunting'?: DiscountHunting;
}


/**
 * @type LodgingPriceBreakdown
 * Breakdown of payment that the user needs to pay outside of the Hopper transaction
 * @export
 */
export type LodgingPriceBreakdown = { LodgingPriceBreakdown: 'CategorySummary' } & CategorySummary | { LodgingPriceBreakdown: 'LineItemBreakdown' } & LineItemBreakdown | { LodgingPriceBreakdown: 'TotalSummary' } & TotalSummary;

export const LodgingPriceBreakdownEnum = {
    CategorySummary: 'CategorySummary',
    LineItemBreakdown: 'LineItemBreakdown',
    TotalSummary: 'TotalSummary'
} as const;

export type LodgingPriceBreakdownEnum = typeof LodgingPriceBreakdownEnum[keyof typeof LodgingPriceBreakdownEnum];


/**
 * @type LodgingPriceQuote
 * @export
 */
export type LodgingPriceQuote = { LodgingPriceQuote: 'PriceQuote' } & PriceQuote | { LodgingPriceQuote: 'PriceQuoteV1' } & PriceQuoteV1 | { LodgingPriceQuote: 'PriceQuoteV2' } & PriceQuoteV2;

export const LodgingPriceQuoteEnum = {
    PriceQuote: 'PriceQuote',
    PriceQuoteV1: 'PriceQuoteV1',
    PriceQuoteV2: 'PriceQuoteV2'
} as const;

export type LodgingPriceQuoteEnum = typeof LodgingPriceQuoteEnum[keyof typeof LodgingPriceQuoteEnum];


/**
 * `advertisedPromotionKind` - The kind of promotion that is being advertised
 * @export
 * @interface LodgingPromotion
 */
export interface LodgingPromotion {
    'promotionType': LodgingPromotionType;
    'discountAmount': Amount;
    'discountPercentage'?: number;
    'advertisedPromotionKind': AdvertisedPromotionKind;
}


export const LodgingPromotionType = {
    DealOfTheDay: 'DealOfTheDay',
    Generic: 'Generic',
    MysteryHotel: 'MysteryHotel',
    SeasonalDeal: 'SeasonalDeal',
    TeamBuy: 'TeamBuy',
    WelcomeSale: 'WelcomeSale'
} as const;

export type LodgingPromotionType = typeof LodgingPromotionType[keyof typeof LodgingPromotionType];


/**
 * autocomplete for lodging query

 * `query` - query by name, coordinates or featured markets
 * @export
 * @interface LodgingQuery
 */
export interface LodgingQuery {
    'query': LocationQuery;
    'sessionToken'?: string;
}
/**
 * `quoteRequest` - Opaque shop value returned during shop. [Must be encrypted]
 * `dates` - checkin and checkout date of the reservation
 * `personId` - individual whose name is on the hotel reservation
 * `additionalGuests` - PersonIDs for each guest, excluding the primary guest.
 * @export
 * @interface LodgingQuoteRequest
 */
export interface LodgingQuoteRequest {
    /**
     * Encrypted, opaque request used to quote the room, for the same lodging
     * @type {any}
     * @memberof LodgingQuoteRequest
     */
    'quoteRequest': any;
    'dates'?: DateRange;
    /**
     * individual whose name is on the hotel reservation
     * @type {string}
     * @memberof LodgingQuoteRequest
     */
    'personId': string;
    /**
     * PersonIDs for each guest, excluding the primary guest.
     * @type {Array<string>}
     * @memberof LodgingQuoteRequest
     */
    'additionalGuests': Array<string>;
}
/**
 * autocomplete suggestions

 * `categories` - list of autocomplete suggestions by Category
 * @export
 * @interface LodgingResponse
 */
export interface LodgingResponse {
    /**
     * list of autocomplete suggestions by Category
     * @type {Array<CategorizedResponse>}
     * @memberof LodgingResponse
     */
    'categories': Array<CategorizedResponse>;
}
/**
 * @type LodgingSelection
 * @export
 */
export type LodgingSelection = { LodgingSelection: 'Location' } & Location | { LodgingSelection: 'LodgingIds' } & LodgingIds | { LodgingSelection: 'Market' } & Market | { LodgingSelection: 'Place' } & Place;

export const LodgingSelectionEnum = {
    Location: 'Location',
    LodgingIds: 'LodgingIds',
    Market: 'Market',
    Place: 'Place'
} as const;

export type LodgingSelectionEnum = typeof LodgingSelectionEnum[keyof typeof LodgingSelectionEnum];


/**
 * 

* `CaponeAvgMargin` - Sort hotels based on their expected average margin from Capone production data, combined with default app score.
     Used primarily for packages search to offer discount
* `CaponeBoostLhcRandom3PreferredDirectWholesale` - Cap1 Sort hotels based on the CaponePreferredDirectWholesale sort, but put the 3 random Lhc
     hotels at the top of the list.
* `CaponeBoostLhcTop3PreferredDirectWholesale` - Cap1 Sort hotels based on the CaponePreferredDirectWholesale sort, but put the top 3 Lhc hotels
     at the top of the list. 
* `CaponeBoostPhcLhcRandom3PreferredDirectWholesale` - Sort hotels based on the CaponePreferredDirectWholesale sort, but put 3 random Phc hotels at the
     top of the list, filling with Lhc if there's not enough Phc to fill the 3 spots.
* `CaponeBoostPhcLhcTop3PreferredDirectWholesale` - Sort hotels based on the CaponePreferredDirectWholesale sort, but put the top 3 Phc hotels at the
     top of the list, filling with Lhc if there's not enough Phc to fill the 3 spots.
 * @export
 * @enum {string}
 */

export const LodgingSortOrder = {
    CaponeAvgMargin: 'CaponeAvgMargin',
    CaponeBoostLhcRandom3PreferredDirectWholesale: 'CaponeBoostLhcRandom3PreferredDirectWholesale',
    CaponeBoostLhcTop3PreferredDirectWholesale: 'CaponeBoostLhcTop3PreferredDirectWholesale',
    CaponeBoostPhcLhcRandom3PreferredDirectWholesale: 'CaponeBoostPhcLhcRandom3PreferredDirectWholesale',
    CaponeBoostPhcLhcTop3PreferredDirectWholesale: 'CaponeBoostPhcLhcTop3PreferredDirectWholesale',
    CaponeLhc: 'CaponeLhc',
    CaponeLhcPreferredDirectWholesale: 'CaponeLhcPreferredDirectWholesale',
    CaponePhc: 'CaponePhc',
    CaponePhcLhcPreferredDirectWholesale: 'CaponePhcLhcPreferredDirectWholesale',
    CaponePhcPreferredDirectWholesale: 'CaponePhcPreferredDirectWholesale',
    CaponePreferredDirectWholesale: 'CaponePreferredDirectWholesale',
    DistanceAscending: 'DistanceAscending',
    MostRecommended: 'MostRecommended',
    NoSortOrder: 'NoSortOrder',
    Price: 'Price',
    SegmentedAppPreferredFirst: 'SegmentedAppPreferredFirst',
    StarRating: 'StarRating',
    UserRating: 'UserRating'
} as const;

export type LodgingSortOrder = typeof LodgingSortOrder[keyof typeof LodgingSortOrder];


/**
 * `city` - lodging city
 * `name` - lodging name
 * `state` - lodging state or province
 * `country` - lodging country
 * @export
 * @interface LodgingSummary
 */
export interface LodgingSummary {
    /**
     * lodging city
     * @type {string}
     * @memberof LodgingSummary
     */
    'city': string;
    /**
     * lodging name
     * @type {string}
     * @memberof LodgingSummary
     */
    'name': string;
    'state': StateOrProvince;
    /**
     * 2 character country code
     * @type {string}
     * @memberof LodgingSummary
     */
    'country': string;
    'id': string;
    'starRating': HotelStarRating;
}


export interface Lodgings {
    'lodgingSelection': LodgingSelection;
    'stayDates'?: DateRange;
    'Id': PlaceIdEnum;
}


/**
 * lodging search by market
 * @export
 * @interface Market
 */
export interface Market {
    'groupingKey': WatchGroupingKey;
    'LodgingSelection': LodgingSelectionEnum;
}


export interface MarketGroupingKey {
    'name': string;
    'fullName': string;
    'id': string;
    'WatchGroupingKey': WatchGroupingKeyEnum;
    'airport': string;
    'dateRange': DateRange;
}


/**
 * Type of meal plan included in the rate
 * @export
 * @interface MealPlan
 */
export interface MealPlan {
    'kind': MealPlanKind;
}


export const MealPlanKind = {
    AllInclusive: 'AllInclusive',
    Breakfast: 'Breakfast',
    BreakfastFor1: 'BreakfastFor1',
    BreakfastFor2: 'BreakfastFor2',
    Dinner: 'Dinner',
    FullBoard: 'FullBoard',
    HalfBoard: 'HalfBoard',
    Lunch: 'Lunch',
    RoomOnly: 'RoomOnly'
} as const;

export type MealPlanKind = typeof MealPlanKind[keyof typeof MealPlanKind];


/**
 * Meal plan for a lodging
 * @export
 * @enum {string}
 */

export const MealPlanRefinement = {
    BreakfastIncluded: 'BreakfastIncluded'
} as const;

export type MealPlanRefinement = typeof MealPlanRefinement[keyof typeof MealPlanRefinement];


export const MediaCategory = {
    Amenity: 'Amenity',
    Bar: 'Bar',
    Dining: 'Dining',
    Exterior: 'Exterior',
    Fitness: 'Fitness',
    GuestRoom: 'GuestRoom',
    Interior: 'Interior',
    Lobby: 'Lobby',
    PointOfInterest: 'PointOfInterest',
    Pool: 'Pool',
    Primary: 'Primary',
    Spa: 'Spa',
    SportsFacility: 'SportsFacility',
    Uncategorized: 'Uncategorized',
    View: 'View'
} as const;

export type MediaCategory = typeof MediaCategory[keyof typeof MediaCategory];


/**
 * @type MerchandisingPlacement
 * Dictates where the offer should be placed - on the rooms list or as an ancillary.
 * @export
 */
export type MerchandisingPlacement = { MerchandisingPlacement: 'RoomsList' } & RoomsList | { MerchandisingPlacement: 'Standalone' } & Standalone;

export const MerchandisingPlacementEnum = {
    RoomsList: 'RoomsList',
    Standalone: 'Standalone'
} as const;

export type MerchandisingPlacementEnum = typeof MerchandisingPlacementEnum[keyof typeof MerchandisingPlacementEnum];


/**
 * There were no guests in the part that met the lodging's required age at check in
 * @export
 * @interface MinimumCheckInAgeNotMet
 */
export interface MinimumCheckInAgeNotMet {
    'LodgingError': LodgingErrorEnum;
}


export interface ModelError {
    'code': string;
    'message'?: string;
}
/**
 * additional response based on moreToken from FollowUpSearch

 * `nextPageToken` - token to get next page list of lodging options
 * `bestOverallOffer` - deprecated (use offers) - travel wallet offer if any
 * `offers` - Wallet Offer per Product
 * `hotelFunnelSession` - Hotel Funnel Session information
 * `parisBestOverallOffer` - deprecated (use offers) - travel wallet offer if any
 * `lodgings` - list of possible lodging options
 * `centroid` - centroid calculated from the coordinates of lodgings returned. Used to position the map.
 * `offerApplicabilityResponse` - deprecated (use offers) - TravelWalletOffer mapped to ActiveOfferId
 * @export
 * @interface More
 */
export interface More {
    'AvailabilityResponse': AvailabilityResponseEnum;
    /**
     * token to get next page list of lodging options
     * @type {string}
     * @memberof More
     */
    'nextPageToken'?: string;
    'bestOverallOffer'?: TravelWalletOffer;
    'offers'?: WalletOfferApplicabilityResponse;
    'hotelFunnelSession'?: HotelFunnelSession;
    'parisBestOverallOffer'?: TravelWalletOffer;
    'trackingPropertiesV2': TrackingProperties;
    /**
     * list of possible lodging options
     * @type {Array<Lodging>}
     * @memberof More
     */
    'lodgings': Array<Lodging>;
    'centroid'?: Coordinates;
    'offerApplicabilityResponse'?: OfferApplicabilityResponse;
}


export interface Nationality {
    'country': string;
}
/**
 * policy result for hotel cancellation that is non-refundable
 * @export
 * @interface NonRefundable
 */
export interface NonRefundable {
    'cancelCopy': Copy;
    'cancelConfirmationCopy'?: Copy;
    'preparedPayment'?: string;
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


/**
 * room is nonrefundable
 * @export
 * @interface NonRefundablePolicy
 */
export interface NonRefundablePolicy {
    'secondaryText'?: string;
    'effectiveRange': EffectiveRange;
    'CancellationPolicy': CancellationPolicyEnum;
    'primaryText': string;
    'cfarInfoBannerText'?: string;
}


/**
 * room is nonrefundable
 * @export
 * @interface NonRefundablePolicyV2
 */
export interface NonRefundablePolicyV2 {
    'secondaryText'?: string;
    'effectiveRange': EffectiveRange;
    'CancellationPolicyV2': CancellationPolicyV2Enum;
    'primaryText': string;
    'cfarInfoBannerText'?: string;
}


export interface NonResizableImage {
    'url': string;
    'category'?: MediaCategory;
    'LodgingMediaAsset': LodgingMediaAssetEnum;
}


export interface NotAvailable {
    'EffectiveRange': EffectiveRangeEnum;
}


/**
 * `isLocked` - Flag indicating the status of NthNightPromotion. true means that the nthNightPromotion is locked. false means the nthNightPromotion is unlocked
 * `description` - Description of the promotion, ie Congrats! You've unlocked a complimentary 4th night
 * `tooltipDescription` - Description for the Tooltip that will be presented in the FE. ie. Receive a compliementary 4th night when booking a stay of at least 4 nights
 * `originalPricePerNight` - Original Price per night
 * `numFreeNight` - Indicates which night is free (e.g., only 1 night that is free)
 * `los` - Length of stay. (i.e. 4 night for this promotion)
 * `promotionEndDate` - The promotion end date
 * `originalPriceTotal` - Total Original Price
 * `promotionStartDate` - The promotion start date
 * @export
 * @interface NthNightPromotion
 */
export interface NthNightPromotion {
    /**
     * Flag indicating the status of NthNightPromotion. true means that the nthNightPromotion is locked. false means the nthNightPromotion is unlocked
     * @type {boolean}
     * @memberof NthNightPromotion
     */
    'isLocked': boolean;
    /**
     * Description of the promotion, ie Congrats! You've unlocked a complimentary 4th night
     * @type {string}
     * @memberof NthNightPromotion
     */
    'description'?: string;
    /**
     * Description for the Tooltip that will be presented in the FE. ie. Receive a compliementary 4th night when booking a stay of at least 4 nights
     * @type {string}
     * @memberof NthNightPromotion
     */
    'tooltipDescription'?: string;
    'originalPricePerNight'?: Prices;
    /**
     * Indicates which night is free (e.g., only 1 night that is free)
     * @type {number}
     * @memberof NthNightPromotion
     */
    'numFreeNight'?: number;
    /**
     * Length of stay. (i.e. 4 night for this promotion)
     * @type {number}
     * @memberof NthNightPromotion
     */
    'los'?: number;
    /**
     * The promotion end date
     * @type {string}
     * @memberof NthNightPromotion
     */
    'promotionEndDate'?: string;
    'originalPriceTotal'?: Prices;
    /**
     * The promotion start date
     * @type {string}
     * @memberof NthNightPromotion
     */
    'promotionStartDate'?: string;
}
/**
 * A payment made in multiple installments via Nupay.
 * @export
 * @interface NupayCredit
 */
export interface NupayCredit {
    'amount': FiatAmount;
    'fees': FiatAmount;
    'numberOfInstallments': number;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * A payment made by debiting against a Nubank account balance.
 * @export
 * @interface NupayDebit
 */
export interface NupayDebit {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


export interface Offer {
    'amount': FiatAmount;
    'TravelWallet': TravelWalletEnum;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * deprecated (use offers) - TravelWalletOffer mapped to ActiveOfferId
 * @export
 * @interface OfferApplicabilityResponse
 */
export interface OfferApplicabilityResponse {
    'bestOfferIdPerProduct': Array<string | null>;
    'bestOfferOverall'?: TravelWalletOffer;
    'offers': { [key: string]: TravelWalletOffer; };
}
export interface OfferNotFound {
    'LodgingError': LodgingErrorEnum;
}


/**
 * Type of the offer
 * @export
 * @enum {string}
 */

export const OfferType = {
    Credit: 'Credit',
    CrossSell: 'CrossSell',
    FirstIncentive: 'FirstIncentive',
    FlashDeal: 'FlashDeal',
    MembersOnly: 'MembersOnly',
    Promotion: 'Promotion',
    Unknown: 'Unknown'
} as const;

export type OfferType = typeof OfferType[keyof typeof OfferType];


/**
 * Override the rate fencing token used for determining applicable rates
 * @export
 * @interface OpaqueToken
 */
export interface OpaqueToken {
    'value': string;
}
export const OpenEnum = {
    Bundle: 'Bundle',
    PostBookingTakeover: 'PostBookingTakeover',
    Standalone: 'Standalone'
} as const;

export type OpenEnum = typeof OpenEnum[keyof typeof OpenEnum];


/**
 * policy result for hotel cancellation that results in a partial refund
 * @export
 * @interface PartialRefund
 */
export interface PartialRefund {
    'cancelConfirmationCopy'?: Copy;
    'preparedPayment'?: string;
    'refundAmount': Amount;
    'cancelCopy': Copy;
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


/**
 * Policy result for hotels that are refundable but already have a refund attached - complex scenario that * for the time being will be handled by Customer Service agent to avoid over/under refund.
 * @export
 * @interface PartiallyRefundableComplex
 */
export interface PartiallyRefundableComplex {
    'customerServiceCopy': Copy;
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


/**
 * room is partially refundable
 * @export
 * @interface PartiallyRefundablePolicyV2
 */
export interface PartiallyRefundablePolicyV2 {
    'secondaryText'?: string;
    'effectiveRange': EffectiveRange;
    'CancellationPolicyV2': CancellationPolicyV2Enum;
    'primaryText': string;
    'cfarInfoBannerText'?: string;
}


export interface Passport {
    'countryOfIssue': string;
    'number': string;
    'expiration': string;
}
/**
 * `Payment` types require shared, known types between client and server. `OpaqueValue`
is used to serialize and deserialize models related to specific `Payment`, but avoid coupling
this purchase interface to the specific `Payment` implementation.

### Attributes
 * `PaymentModel.Create` **required**
 *    Request model used to add the payment to an order during checkout.
 * `PaymentModel.Authorize` **optional**
 *    Request model used to fulfill a payment challenge during the 

 * PaymentModel.Quoted **optional** 
 *    Model displayed for payments added prior to "Confirm and Book" shown in the "Payment Breakdown".

 * PaymentModel.ListView - **required** 
 *    Model used to display charged amount on confirmation page, my trips, or any other post-booking display.
 * PaymentModel.Error - **required** 
 *    Error model when processing the payment.

* `AirChfarExerciseDiscount` - Representation of a discount from exercising a Chfar on a new flight.\n
    Interface defined in `b2b-interfaces/air-chfar`.
* `AirPriceFreezeExerciseDiscount` - Representation of the discount price delta from exercising a price freeze on a frozen flight.\n
    Interface defined in `b2b-interfaces/air-price-freeze`.
* `ApplePay` - Payments performed through Apple Pay.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
* `Card` - Payments made via Spreedly card api. Allows orders to be purchased with credit or debit cards.\n
    Interface defined in `b2b-interfaces/card`.
* `DisruptionProtectionCredit` - Representation of the exercising of a disruption protection, on a new flight.\n
    Interface defined in `Tysons/server`.
* `FintechBundleDiscount` - Representation of a synthetic discount for selecting both disruption protection + CFAR offers.\n
    Interface defined in `b2b-interfaces/air-disruption`.,
    
* `GooglePay` - Payments performed through Google Pay.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
* `HotelPriceFreezeDeposit` - Representation of a discount for purchasing a frozen hotel, amounting to the value of the price freeze.\n
    Interface defined in `Tysons/server`.
* `HotelPriceFreezeExerciseDiscount` - Representation of a discount for purchasing a frozen hotel, amounting to the discount price delta from
    exercising of the price freeze.\n
    Interface defined in `Tysons/server`.
* `KCP` - Payments performed through Korea Cyber Payment (KCP).\n
    Interface defined in `b2b-interfaces/payment-methods`.
* `LodgingCfarDiscount` - Representation of a discount applied to an order from a negative lodging CFAR premium\n
    Interface defined in `b2b-interfaces/lodging-cfar`.
* `NequiPocketPayment` - Payments via nequi pocket pay. Can only be used for tenant=nequi.\n
    Interface defined in `b2bportal-nequi-bff`.
* `NupayPayment` - Nubank, tenant specific, payment integration. Can only be used for tenant=nubank.\n
    Interface defined in `b2bportal-nubank-bff`.
* `PackageSyntheticDiscount` - Representation of a synthetic discount for booking a hotel+flight package.\n
    Interface defined in `Tysons/server`.
* `PayPal` - Payments performed through PayPal.\n
    Interface defined in `b2bportal-hopper-web-bff`.
* `PriceFreezeExerciseDiscount` - Representation of a discount for purchasing a frozen product, amounting to the discount price delta from
    exercising of the price freeze.\n
    Interface defined in `b2b-interfaces/pricefreeze`.
* `Rewards` - Payments made via Capital One travel rewards. Can only be used for tenant=capone,capone-corporate.\n
    Interface defined in `Tysons/server`
* `TravelWalletCredit` - Representation of travel wallet credits or carror cash, stored in `Scranton`.\n
    Interface defined in `Tysons/server`.
* `TravelWalletOffer` - Representation of any offer sourced from `Scranton`.\n
    Interface defined in `Tysons/server`.
* `UberPayment` - Uber operated payment processor. Can only be used for tenant=uber.\n
    Interface defined in `b2bportal-uber-bff`.
* `VirginAuVffPoints` - Representation of Virgin Australia's Velocity Frequent Flyer Points which can be used to purchase travel.\n
    Interface defined in `b2bportal-virgin-au-bff`.,
    
* `Wallet` - Payments performed through `Scranton` wallet.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
 * @export
 * @enum {string}
 */

export const Payment = {
    AirChfarExerciseDiscount: 'AirChfarExerciseDiscount',
    AirPriceFreezeExerciseDiscount: 'AirPriceFreezeExerciseDiscount',
    ApplePay: 'ApplePay',
    Card: 'Card',
    DisruptionProtectionCredit: 'DisruptionProtectionCredit',
    FintechBundleDiscount: 'FintechBundleDiscount',
    GooglePay: 'GooglePay',
    HotelPriceFreezeDeposit: 'HotelPriceFreezeDeposit',
    HotelPriceFreezeExerciseDiscount: 'HotelPriceFreezeExerciseDiscount',
    KCP: 'KCP',
    LodgingCfarDiscount: 'LodgingCfarDiscount',
    NequiPocketPayment: 'NequiPocketPayment',
    NupayPayment: 'NupayPayment',
    PackageSyntheticDiscount: 'PackageSyntheticDiscount',
    PayPal: 'PayPal',
    PriceFreezeExerciseDiscount: 'PriceFreezeExerciseDiscount',
    Rewards: 'Rewards',
    TravelWalletCredit: 'TravelWalletCredit',
    TravelWalletOffer: 'TravelWalletOffer',
    UberPayment: 'UberPayment',
    VirginAuVffPoints: 'VirginAuVffPoints',
    Wallet: 'Wallet'
} as const;

export type Payment = typeof Payment[keyof typeof Payment];


/**
 * @type PaymentAmount
 * Deprecated: remove after FE switches to payNowTotal
 * @export
 */
export type PaymentAmount = { PaymentAmount: 'FiatAmount' } & FiatAmount | { PaymentAmount: 'RewardsAmount' } & RewardsAmount;

export const PaymentAmountEnum = {
    FiatAmount: 'FiatAmount',
    RewardsAmount: 'RewardsAmount'
} as const;

export type PaymentAmountEnum = typeof PaymentAmountEnum[keyof typeof PaymentAmountEnum];


/**
 * This model is attached to each reservation in order to display a payment breakdown in My Trips

 * `payments` - deprecated, use `paymentLineItems` instead
 * `paymentLineItems` - All payments used in the purchase of the Itinerary.
 * @export
 * @interface PaymentBreakdown
 */
export interface PaymentBreakdown {
    /**
     * deprecated, use `paymentLineItems` instead
     * @type {Array<PaymentLineItem>}
     * @memberof PaymentBreakdown
     */
    'payments': Array<PaymentLineItem>;
    /**
     * All payments used in the purchase of the Itinerary.
     * @type {Array<PaymentOpaqueValue>}
     * @memberof PaymentBreakdown
     */
    'paymentLineItems': Array<PaymentOpaqueValue>;
}
/**
 * Payment to provider failed
 * @export
 * @interface PaymentFailed
 */
export interface PaymentFailed {
    'LodgingError': LodgingErrorEnum;
}


/**
 * @type PaymentLineItem
 * @export
 */
export type PaymentLineItem = { PaymentLineItem: 'ApplePay' } & ApplePay | { PaymentLineItem: 'GooglePay' } & GooglePay | { PaymentLineItem: 'NupayCredit' } & NupayCredit | { PaymentLineItem: 'NupayDebit' } & NupayDebit | { PaymentLineItem: 'PriceFreezeExerciseDiscount' } & PriceFreezeExerciseDiscount | { PaymentLineItem: 'Rewards' } & Rewards | { PaymentLineItem: 'TravelWallet' } & TravelWallet | { PaymentLineItem: 'UserCard' } & UserCard;

export const PaymentLineItemEnum = {
    ApplePay: 'ApplePay',
    GooglePay: 'GooglePay',
    NupayCredit: 'NupayCredit',
    NupayDebit: 'NupayDebit',
    PriceFreezeExerciseDiscount: 'PriceFreezeExerciseDiscount',
    Rewards: 'Rewards',
    TravelWallet: 'TravelWallet',
    UserCard: 'UserCard'
} as const;

export type PaymentLineItemEnum = typeof PaymentLineItemEnum[keyof typeof PaymentLineItemEnum];


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface PaymentOpaqueValue
 */
export interface PaymentOpaqueValue {
    'type': Payment;
    'value': any;
}


/**
 * `payNowTotal` - The amounts to be paid now in the user's preferred currency.
 * `payLaterTotal` - The amounts to be paid later at the property in the user's preferred currency. This amount may differ at the time of payment due to fluctuation of exchange rates.
 * `payLaterTotalLocalCurrency` - The amounts to be paid later at the property in the local currency used at the property.
 * @export
 * @interface PaymentSchedule
 */
export interface PaymentSchedule {
    'payNowTotal'?: Prices;
    'payLaterTotal'?: Prices;
    'payLaterTotalLocalCurrency'?: Prices;
}
/**
 * policy result for hotel in a pending status
 * @export
 * @interface Pending
 */
export interface Pending {
    'HotelCancelScenario': HotelCancelScenarioEnum;
}


export interface Person {
    'givenName': string;
    'knownTravelerNumber'?: string;
    'phoneNumber'?: string;
    'middleName'?: string;
    'emailAddress'?: string;
    'driverLicense'?: DriverLicense;
    'surname': string;
    'dateOfBirth': string;
    'passport'?: Passport;
    'id': string;
    'redressNumberIssuingCountry'?: string;
    'frequentFlyer': { [key: string]: FrequentFlyerNumber; };
    'hotelLoyalty': { [key: string]: HotelLoyaltyNumber; };
    'redressNumber'?: string;
    'nationality'?: Nationality;
    'createdAt': string;
    'assistance': Array<Assistance>;
    'knownTravelerNumberIssuingCountry'?: string;
    'lastBookedWith'?: string;
    'gender': Gender;
}


/**
 * lodging search by place
 * @export
 * @interface Place
 */
export interface Place {
    'placeId': string;
    'searchTerm': string;
    'placeTypes': Array<string>;
    'LodgingSelection': LodgingSelectionEnum;
}


/**
 * @type PlaceId
 * @export
 */
export type PlaceId = { Id: 'HotelMarket' } & HotelMarket | { Id: 'Lodgings' } & Lodgings;

export const PlaceIdEnum = {
    HotelMarket: 'HotelMarket',
    Lodgings: 'Lodgings'
} as const;

export type PlaceIdEnum = typeof PlaceIdEnum[keyof typeof PlaceIdEnum];


export const PlaceType = {
    lodging: 'lodging'
} as const;

export type PlaceType = typeof PlaceType[keyof typeof PlaceType];


/**
 * mobile or desktop user
 * @export
 * @enum {string}
 */

export const Platform = {
    Desktop: 'Desktop',
    Mobile: 'Mobile'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];


export interface Policy {
    'title': string;
    'text': string;
}
export interface PolicyCompliance {
    'isInPolicy': boolean;
    'reasons': Array<string>;
}
export interface Premium {
    'amount': Prices;
}
/**
 * difference in pricing for the shopped trip
 * @export
 * @interface PriceChange
 */
export interface PriceChange {
    'direction': PriceChangeDirection;
    'priceChangePercentage': number;
}


export const PriceChangeDirection = {
    Decrease: 'Decrease',
    Increase: 'Increase'
} as const;

export type PriceChangeDirection = typeof PriceChangeDirection[keyof typeof PriceChangeDirection];


/**
 * The value of a Price Freeze Exercise Discount
 * @export
 * @interface PriceFreezeExerciseDiscount
 */
export interface PriceFreezeExerciseDiscount {
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


/**
 * `lodgingCollection` - what hotel collection, if any, the reservation belongs to
 * `cancellationPolicy` - deprecated, use cancellationPolicyV2 instead
 * `bookingReservationId` - unique internal identifier of the reservation
 * `productInfo` - offer/credit information applicable to the reservation
 * `isLuxuryCollection` - deprecated: use lodgingCollection
 * `priceChange` - difference in pricing for the shopped trip
 * `lodging` - Describes the property being quoted.
 * `cancellationPolicyV2` - cancellation policy indicating whether the hotel is fully, partially or non-refundable at the time price quote
 * `protectionOffers` - protection ancillary offers for the quote
 * @export
 * @interface PriceQuote
 */
export interface PriceQuote {
    'lodgingCollection': LodgingCollection;
    'cancellationPolicy': CancellationPolicy;
    'checkInInstructions': CheckInInstructions;
    /**
     * unique internal identifier of the reservation
     * @type {string}
     * @memberof PriceQuote
     */
    'bookingReservationId': string;
    'productInfo': ProductInfo;
    /**
     * deprecated: use lodgingCollection
     * @type {boolean}
     * @memberof PriceQuote
     */
    'isLuxuryCollection': boolean;
    'priceChange'?: PriceChange;
    'lodging': QuoteLodgingData;
    'cancellationPolicyV2'?: CancellationPolicyV2;
    'LodgingPriceQuote': LodgingPriceQuoteEnum;
    'pricing': Pricing;
    'protectionOffers': ProtectionOffers;
}


export interface PriceQuotePollResponse {
    'priceQuote': TrackedQuoteResponse;
}
/**
 * `lodgingCollection` - what lodging collection, if any, this belongs to
 * `personId` - individual whose name is on the hotel reservation
 * `emailAddress` - address to send user contact messages to
 * `isLuxuryCollection` - Deprecated, use lodgingCollection
 * `dates` - checkin and checkout date of the reservation
 * `token` - random UUID used to identify the lodging session
 * `quoteRequest` - opaque data obtained from the shop response
 * @export
 * @interface PriceQuoteScheduleRequest
 */
export interface PriceQuoteScheduleRequest {
    'lodgingCollection': LodgingCollection;
    'city'?: string;
    'name'?: string;
    /**
     * individual whose name is on the hotel reservation
     * @type {string}
     * @memberof PriceQuoteScheduleRequest
     */
    'personId': string;
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof PriceQuoteScheduleRequest
     */
    'phoneNumber': string;
    'bedTypes'?: BedTypeList;
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof PriceQuoteScheduleRequest
     */
    'emailAddress': string;
    'country'?: string;
    'id'?: string;
    /**
     * Deprecated, use lodgingCollection
     * @type {boolean}
     * @memberof PriceQuoteScheduleRequest
     */
    'isLuxuryCollection': boolean;
    'dates': DateRange;
    'additionalGuests'?: Array<string>;
    'starRating'?: HotelStarRating;
    /**
     * random UUID used to identify the lodging session
     * @type {string}
     * @memberof PriceQuoteScheduleRequest
     */
    'token': string;
    'providerName'?: string;
    /**
     * Encrypted, opaque request used to quote the room, for the same lodging
     * @type {any}
     * @memberof PriceQuoteScheduleRequest
     */
    'quoteRequest': any;
}


/**
 * For CapOne shopping-cart migration

 * `cancellationPolicy` - The cancellation policy
 * `cancellationPolicyV2` - cancellation policy indicating whether the hotel is fully, partially or non-refundable at the time price quote. Currently only used by cfar.
 * @export
 * @interface PriceQuoteV1
 */
export interface PriceQuoteV1 {
    'cancellationPolicy': CancellationPolicy;
    'checkInInstructions': CheckInInstructions;
    'priceChange'?: PriceChange;
    'cancellationPolicyV2'?: CancellationPolicyV2;
    'LodgingPriceQuote': LodgingPriceQuoteEnum;
    'pricing': Pricing;
}


/**
 * PriceQuote to be used in b2b portals.

 * `bedType` - List of bed types in quoted room. Optional as every bff might not require this field
 * `checkInInstructions` - Check in instructions for selected hotel. Optional as every bff might not require this field
 * `hotelName` - Hotel name of selected hotel product. Optional as every bff might not require this field
 * `cancellationDetails` - Cancellation details for selected room. Optional as every bff might not require this field
 * `roomName` - Room name of selected hotel product. Optional as every bff might not require this field
 * @export
 * @interface PriceQuoteV2
 */
export interface PriceQuoteV2 {
    /**
     * List of bed types in quoted room. Optional as every bff might not require this field
     * @type {Array<BedType>}
     * @memberof PriceQuoteV2
     */
    'bedType'?: Array<BedType>;
    'checkInInstructions'?: CheckInInstructions;
    /**
     * Hotel name of selected hotel product. Optional as every bff might not require this field
     * @type {string}
     * @memberof PriceQuoteV2
     */
    'hotelName'?: string;
    'cancellationDetails'?: CancellationPolicyV2;
    'additionalPolicies': Array<CheckInPolicy>;
    /**
     * Room name of selected hotel product. Optional as every bff might not require this field
     * @type {string}
     * @memberof PriceQuoteV2
     */
    'roomName'?: string;
    'LodgingPriceQuote': LodgingPriceQuoteEnum;
    'pricingV1': PricingV1;
}


export interface PriceRange {
    'min'?: number;
    'max'?: number;
}
/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
/**
 * `tripTotal` - all charges including taxes and fees owed at the hotel (grandTotal + owedAtHotel)
 * `grandTotal` - Deprecated: remove after FE switches to payNowTotal
 * `promotion` - Hotel-funded promotion.
 * `subtotal` - Price after adding markup but before adding taxes
 * `payNowTotal` - net + markup + taxes
 * @export
 * @interface Pricing
 */
export interface Pricing {
    'tripTotal': Prices;
    'feeBreakdown': Fees;
    'grandTotal': PaymentAmount;
    'rooms': Prices;
    'taxes': Prices;
    'promotion'?: LodgingPromotion;
    'discounts': Array<PricingDiscount>;
    'currency': string;
    'subtotal': Prices;
    'taxBreakdown': Taxes;
    'payNowTotal': Prices;
}
/**
 * `priceDifference` - amount difference from lowest rate from shop. lowest price is 0
 * `lowestPriceRateId` - RateId of the lowest price in the shop
 * @export
 * @interface PricingDifference
 */
export interface PricingDifference {
    'priceDifference': Prices;
    'lowestPriceRateId': RateId;
}
/**
 * Discount applied to the room will have a negative value.
 * @export
 * @interface PricingDiscount
 */
export interface PricingDiscount {
    'value': Prices;
    'description': string;
}
/**
 * `taxesAndFeesTotal` - The total prices of taxes and fees, including pay now and pay later amounts.
 * `tripTotal` - The total price to be paid by the customer, i.e. sum of rooms, taxes and fees to be pay now and later.
 * `taxesAndFeesDetails` - The taxes and fees total detail
 * `subTotal` - The hotel price excluding taxes and discounts.
 * `dailyRate` - The price of the room per night.
 * `promotion` - Hotel-funded promotion.
 * `paymentSchedule` - The breakdown of payment schedules.
 * `discounts` - A list of applied discounts.
 * `stayNights` - The number of nights staying.
 * @export
 * @interface PricingV1
 */
export interface PricingV1 {
    'taxesAndFeesTotal'?: Prices;
    'tripTotal': Prices;
    'taxesAndFeesDetails'?: TaxesAndFeesDetails;
    'subTotal': Prices;
    'dailyRate': Prices;
    'promotion'?: LodgingPromotion;
    'paymentSchedule': PaymentSchedule;
    /**
     * A list of applied discounts.
     * @type {Array<PricingDiscount>}
     * @memberof PricingV1
     */
    'discounts': Array<PricingDiscount>;
    /**
     * The number of nights staying.
     * @type {number}
     * @memberof PricingV1
     */
    'stayNights': number;
}
/**
 * The `class` of the product.
This is named product class to generalize from the concept of fare class
(aka. fare shelf) of an air ticket so that we can apply it to a hotel booking, too.
 * @export
 * @enum {string}
 */

export const ProductClass = {
    basic: 'basic',
    economy: 'economy',
    enhanced: 'enhanced',
    luxury: 'luxury',
    premium: 'premium'
} as const;

export type ProductClass = typeof ProductClass[keyof typeof ProductClass];


/**
 * @type ProductInfo
 * offer/credit information applicable to the reservation
 * @export
 */
export type ProductInfo = { ProductInfo: 'Hotel' } & Hotel;

export const ProductInfoEnum = {
    Hotel: 'Hotel'
} as const;

export type ProductInfoEnum = typeof ProductInfoEnum[keyof typeof ProductInfoEnum];


export interface ProductNotFound {
    'LodgingError': LodgingErrorEnum;
}


/**
 * Details of the price for a purchase. Used to determine offer applicability and for the purpose of
computing the cash back amount credited to the user on completion.

 * `sellPrice` - The price of the booking to be paid by the user in this transaction with Hopper.
It includes discounts, ancillaries, and taxes/fees due now; it excludes taxes/fees due later.
 * `preDiscountTotal` - The undiscounted price of the booking.
It includes ancillaries and taxes/fees due now; it excludes discounts and taxes/fees due later.
 * `expectedRevenue` - The total expected revenue for this booking.
 * `ancillaryTotal` - The total price to be paid by the user for the ancillaries of the purchase.
 * `preDiscountGrandTotal` - The undiscounted price of the _trip_.
It includes ancillaries and taxes/fees due now _and at check-in_; it excludes discounts.
 * `basePrice` - The base price of the booking that we got from providers.
It excludes taxes/fees, discounts, ancillaries.
 * `productClass` - The `class` of the product.
This is named product class to generalize from the concept of fare class
(aka. fare shelf) of an air ticket so that we can apply it to a hotel booking, too.
 * `grossBookValue` - The total price of the travel product.
It includes taxes/fees due now; it excludes discounts, ancillaries, and taxes/fees due later.
 * `currency` - The currency of this booking and all the numbers herein.
 * @export
 * @interface ProductPricing
 */
export interface ProductPricing {
    /**
     * The price of the booking to be paid by the user in this transaction with Hopper.
It includes discounts, ancillaries, and taxes/fees due now; it excludes taxes/fees due later.
     * @type {number}
     * @memberof ProductPricing
     */
    'sellPrice': number;
    /**
     * The undiscounted price of the booking.
It includes ancillaries and taxes/fees due now; it excludes discounts and taxes/fees due later.
     * @type {number}
     * @memberof ProductPricing
     */
    'preDiscountTotal': number;
    /**
     * The total expected revenue for this booking.
     * @type {number}
     * @memberof ProductPricing
     */
    'expectedRevenue'?: number;
    /**
     * The total price to be paid by the user for the ancillaries of the purchase.
     * @type {number}
     * @memberof ProductPricing
     */
    'ancillaryTotal': number;
    /**
     * The undiscounted price of the _trip_.
It includes ancillaries and taxes/fees due now _and at check-in_; it excludes discounts.
     * @type {number}
     * @memberof ProductPricing
     */
    'preDiscountGrandTotal': number;
    /**
     * The base price of the booking that we got from providers.
It excludes taxes/fees, discounts, ancillaries.
     * @type {number}
     * @memberof ProductPricing
     */
    'basePrice': number;
    'productClass': ProductClass;
    /**
     * The total price of the travel product.
It includes taxes/fees due now; it excludes discounts, ancillaries, and taxes/fees due later.
     * @type {number}
     * @memberof ProductPricing
     */
    'grossBookValue': number;
    /**
     * The currency of this booking and all the numbers herein.
     * @type {string}
     * @memberof ProductPricing
     */
    'currency': string;
}


/**
 * number of lodging options to return
 * @export
 * @interface ProgressiveConfig
 */
export interface ProgressiveConfig {
    'pageSize'?: number;
}
/**
 * protection ancillary offers for the quote
 * @export
 * @interface ProtectionOffers
 */
export interface ProtectionOffers {
    'lfarOffer'?: LfarOffer;
}
/**
 * Provider not defined
 * @export
 * @interface ProviderNotDefined
 */
export interface ProviderNotDefined {
    'LodgingError': LodgingErrorEnum;
}


export interface ProviderOverrideText {
    'taxRecoveryChargesAndServiceFees'?: string;
}
/**
 * Quote is no longer considered valid as it has expired
 * @export
 * @interface QuoteExpired
 */
export interface QuoteExpired {
    'LodgingError': LodgingErrorEnum;
}


/**
 * `id` - Identifies the property.
 * @export
 * @interface QuoteLodgingData
 */
export interface QuoteLodgingData {
    /**
     * Identifies the property.
     * @type {string}
     * @memberof QuoteLodgingData
     */
    'id': string;
}
/**
 * unique identifier for a rate. maps to com.hopper.common.model.api.Paris.RateId
 * @export
 * @interface RateId
 */
export interface RateId {
    'value': string;
}
/**
 * The rate that was quoted is no longer available
 * @export
 * @interface RateNotAvailable
 */
export interface RateNotAvailable {
    'LodgingError': LodgingErrorEnum;
}


/**
 * room is fully or partially refundable
 * @export
 * @interface RefundablePolicy
 */
export interface RefundablePolicy {
    'secondaryText'?: string;
    'effectiveRange': EffectiveRange;
    'CancellationPolicy': CancellationPolicyEnum;
    'primaryText': string;
    'cfarInfoBannerText'?: string;
}


/**
 * `bookingEmail` - email used for booking
 * `lodgingCollection` - what lodging collection, if any, this reservation belongs to
 * `adultCount` - number of adults included in reservation
 * `cancellationPolicy` - deprecated, use cancellationPolicyV2 instead
 * `reservationId` - external identifier of the reservation
 * `reservationBookingId` - unique internal identifier of the reservation
 * `mealPlan` - Type of meal plan included in the rate
 * `trackingProperties` - deprecated
 * `guests` - all names attached to the reservation
 * `hotelConfirmationCode` - hotel confirmation code provided by the hotel post-booking
 * `isLuxuryCollection` - Deprecated, use lodgingCollection
 * `bookedAncillaryIds` - booked ancillary ids attached to lodging reservation
 * `trackingPropertiesV2` - properties used for tracking and identifying the reservation
 * `createdAt` - time reservation is initially made
 * `childCount` - number of children included in reservation
 * `cancellationPolicyV2` - cancellation policy indicating whether the hotel is fully, partially or non-refundable at the time of booking
 * @export
 * @interface Reservation
 */
export interface Reservation {
    /**
     * email used for booking
     * @type {string}
     * @memberof Reservation
     */
    'bookingEmail'?: string;
    'lodgingCollection': LodgingCollection;
    'paymentCurrency': string;
    /**
     * number of adults included in reservation
     * @type {number}
     * @memberof Reservation
     */
    'adultCount'?: number;
    'cancellationPolicy': CancellationPolicy;
    'state': ReservationState;
    /**
     * external identifier of the reservation
     * @type {string}
     * @memberof Reservation
     */
    'reservationId': string;
    'bedTypes': Rooms;
    'lodgingId': string;
    /**
     * unique internal identifier of the reservation
     * @type {string}
     * @memberof Reservation
     */
    'reservationBookingId': string;
    'lodgingData'?: LodgingData;
    'mealPlan'?: MealPlan;
    /**
     * deprecated
     * @type {any}
     * @memberof Reservation
     */
    'trackingProperties'?: any;
    /**
     * all names attached to the reservation
     * @type {Array<Person>}
     * @memberof Reservation
     */
    'guests': Array<Person>;
    'hotelConfirmationCode'?: HotelConfirmationCode;
    'checkOutDate': string;
    /**
     * Deprecated, use lodgingCollection
     * @type {boolean}
     * @memberof Reservation
     */
    'isLuxuryCollection': boolean;
    'bookedAncillaryIds'?: BookedAncillaryIds;
    'roomInfo'?: RoomInfo;
    'bookedRooms': Array<BookedRooms>;
    'trackingPropertiesV2': TrackingProperties;
    'checkInDate': string;
    /**
     * time reservation is initially made
     * @type {string}
     * @memberof Reservation
     */
    'createdAt': string;
    'paymentSchedule'?: string;
    'additionalInfo'?: AdditionalInfo;
    /**
     * number of children included in reservation
     * @type {number}
     * @memberof Reservation
     */
    'childCount'?: number;
    'cancellationPolicyV2'?: CancellationPolicyV2;
    'providerOverrideText': ProviderOverrideText;
    'pricing': Pricing;
    'policies': Array<CheckInPolicy>;
}


export interface ReservationFailed {
    'errors': Array<Error>;
    'Response': ReservationResponseEnum;
}


export interface ReservationPending {
    'Response': ReservationResponseEnum;
}


/**
 * @type ReservationResponse
 * @export
 */
export type ReservationResponse = { Response: 'Failed' } & ReservationFailed | { Response: 'Pending' } & ReservationPending | { Response: 'Success' } & ReservationSuccess;

export const ReservationResponseEnum = {
    Failed: 'Failed',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type ReservationResponseEnum = typeof ReservationResponseEnum[keyof typeof ReservationResponseEnum];


/**
 * @type ReservationState
 * @export
 */
export type ReservationState = { ReservationState: 'CancellationFailure' } & ReservationStateCancellationFailure | { ReservationState: 'Cancelled' } & ReservationStateCancelled | { ReservationState: 'Confirmed' } & ReservationStateConfirmed | { ReservationState: 'Pending' } & ReservationStatePending;

export interface ReservationStateCancellationFailure {
    'ReservationState': ReservationStateEnum;
}


export interface ReservationStateCancelled {
    'ReservationState': ReservationStateEnum;
}


export interface ReservationStateConfirmed {
    'ReservationState': ReservationStateEnum;
}


export const ReservationStateEnum = {
    CancellationFailure: 'CancellationFailure',
    Cancelled: 'Cancelled',
    Confirmed: 'Confirmed',
    Pending: 'Pending'
} as const;

export type ReservationStateEnum = typeof ReservationStateEnum[keyof typeof ReservationStateEnum];


export interface ReservationStatePending {
    'ReservationState': ReservationStateEnum;
}


export interface ReservationSuccess {
    'value': Reservation;
    'Response': ReservationResponseEnum;
}


export interface ResizableImage {
    'url': string;
    'category'?: MediaCategory;
    'LodgingMediaAsset': LodgingMediaAssetEnum;
}


export const ResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type ResponseEnum = typeof ResponseEnum[keyof typeof ResponseEnum];


export interface Restricted {
    'checkInTimeFrom'?: string;
    'checkInTimeUntil'?: string;
    'CheckInTime': CheckInTimeEnum;
}


/**
 * This model represents rewards payments (points/miles/cash)
 * @export
 * @interface Rewards
 */
export interface Rewards {
    'accountDisplayName': string;
    'amount': RewardsAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


export interface RewardsAmount {
    'rewardsAccountId': string;
    'fiatValue': Amount;
    'rewardsPrice': AccountPrice;
    'PaymentAmount': PaymentAmountEnum;
}


export interface Room {
    'roomType': RoomType;
    'bedTypes': BedTypeList;
}


/**
 * `name` - room name (if any)
 * `sizeSqFt` - square feet (if listed)
 * `description` - room description (if any)
 * `amenities` - amenities with additional details (if any)
 * `media` - media assets of related to the room or lodging
 * `maxChildren` - max number of children (if listed)
 * `maxAdults` - max number of adults (if listed)
 * `beds` - list of beds and type
 * @export
 * @interface RoomInfo
 */
export interface RoomInfo {
    'roomId': string;
    /**
     * room name (if any)
     * @type {string}
     * @memberof RoomInfo
     */
    'name'?: string;
    /**
     * square feet (if listed)
     * @type {number}
     * @memberof RoomInfo
     */
    'sizeSqFt'?: number;
    /**
     * room description (if any)
     * @type {string}
     * @memberof RoomInfo
     */
    'description'?: string;
    /**
     * amenities with additional details (if any)
     * @type {Array<AmenityStatus>}
     * @memberof RoomInfo
     */
    'amenities': Array<AmenityStatus>;
    /**
     * media assets of related to the room or lodging
     * @type {Array<LodgingMediaAsset>}
     * @memberof RoomInfo
     */
    'media': Array<LodgingMediaAsset>;
    'corporateTravel'?: CorporateTravel;
    /**
     * max number of children (if listed)
     * @type {number}
     * @memberof RoomInfo
     */
    'maxChildren'?: number;
    /**
     * max number of adults (if listed)
     * @type {number}
     * @memberof RoomInfo
     */
    'maxAdults'?: number;
    'beds': BedTypeList;
}
/**
 * `roomInfo` - general information about the room
 * `products` - room and price breakdown
 * `pricingDifference` - Map of the pricing differences from the lowest rate offered. For example, if there are prices [100, 120, 150], the pricingDifferences would be [0, 20, 50].
 * @export
 * @interface RoomInfoProducts
 */
export interface RoomInfoProducts {
    'roomInfo': RoomInfo;
    /**
     * room and price breakdown
     * @type {Array<RoomProduct>}
     * @memberof RoomInfoProducts
     */
    'products': Array<RoomProduct>;
    'trackingPropertiesV2': TrackingProperties;
    /**
     * Map of the pricing differences from the lowest rate offered. For example, if there are prices [100, 120, 150], the pricingDifferences would be [0, 20, 50].
     * @type {{ [key: string]: PricingDifference; }}
     * @memberof RoomInfoProducts
     */
    'pricingDifference': { [key: string]: PricingDifference; };
}
/**
 * Display if the current lodging is a pay later or pay now. Pay later rates will indicate on payAtHotelBreakdown.
 * @export
 * @enum {string}
 */

export const RoomPaymentSchedule = {
    PayLater: 'PayLater',
    PayNow: 'PayNow'
} as const;

export type RoomPaymentSchedule = typeof RoomPaymentSchedule[keyof typeof RoomPaymentSchedule];


/**
 * `tripTotal` - total price include what is paid at the property
 * `cancellationPolicy` - deprecated, use cancellationPolicyV2 instead
 * `nthNightPromotion` - NthNightPromotion for luxury premier collections
 * `cfarQuote` - CFAR offers available for this room. When None, backwards compatibility or CFAR was not called. When Some, CFAR offer service was called.
 * `bedTypes` - list of rooms, beds and bedtypes
 * `nightlyDiscountAware` - per night discount
 * `feeBreakdown` - fees paid at the property
 * `perNightSellRate` - per night sell price
 * `cfarQuotes` - CFAR offers available for this room. When Nil, backwards compatibility or CFAR was not called. Otherwise, populated with offers.
 * `earnAmount` - EarnAmount for the room.
 * `mealPlan` - the type of meal plan included in the rate
 * `opaqueRoomRateDetails` - encrypted details for the given rate and room.
 * `total` - total price excluding what is paid at the property
 * `ancillaryOpaque` - encrypted details used for making calls to ancillaries
 * `loyaltyProgramCode` - program loyalty code from the hotel. None if hotel is ineligible for loyalty programs, or not implemented
 * `hopperRateCategory` - A closed set of categories to tag rates according to Hopper definitions.
 * `priceFreezeOpaque` - encrypted rate details used to fetch price freeze offers
 * `amenities` - room rate amenities with additional details (if any)
 * `nightlyDiscountAwareTaxesAndFeesIncluded` - per night discount including taxes and fees.Use this field instead of [[nightlyDiscountAware]] when [[LodgingPrice.displayTaxesAndFeesIncludedNightlyPrice]] is true
 * `promotion` - room-specific promotion
 * `perNightTotal` - per night total price
 * `totalDiscountAware` - total discount
 * `providerName` - provider name
 * `discounts` - list of discounts and description
 * `isCorporate` - is a corporate rate - set from the provider - will have corporate specific discounts
 * `totalDiscountAwareTaxesAndFeesIncluded` - total discount including taxes and fees.Use this field instead of [[totalDiscountAware]] when [[LodgingPrice.displayTaxesAndFeesIncludedNightlyPrice]] is true
 * `perNightBaseRate` - per night base price
 * `taxBreakdown` - taxes collected
 * `baseRate` - base price
 * `rateId` - unique identifier for a rate
 * `experienceDescription` - Localized description of the experience the customer can expect from buying this product (meal plan, bath, extras, etc.
 * `cancellationPolicyV2` - cancellation policy indicating whether the hotel is fully, partially or non-refundable at the time of shopping
 * `perNightSellRateTaxesAndFeesIncluded` - per night sell price including taxes and fees.Use this field instead of [[perNightSellRate]] when [[LodgingPrice.displayTaxesAndFeesIncludedNightlyPrice]] is true
 * `sellRate` - sell price
 * `policies` - additional policies
 * @export
 * @interface RoomProduct
 */
export interface RoomProduct {
    'tripTotal': Prices;
    'cancellationPolicy': CancellationPolicy;
    'nthNightPromotion'?: NthNightPromotion;
    'cfarQuote'?: CfarRateQuote;
    'bedTypes': Rooms;
    'nightlyDiscountAware': DiscountAwarePrices;
    'feeBreakdown': Fees;
    'perNightSellRate': Prices;
    /**
     * CFAR offers available for this room. When Nil, backwards compatibility or CFAR was not called. Otherwise, populated with offers.
     * @type {Array<CfarRateQuote>}
     * @memberof RoomProduct
     */
    'cfarQuotes': Array<CfarRateQuote>;
    'earnAmount'?: EarnAmount;
    'roomPaymentSchedule'?: RoomPaymentSchedule;
    'mealPlan'?: MealPlan;
    /**
     * encrypted details for the given rate and room.
     * @type {string}
     * @memberof RoomProduct
     */
    'opaqueRoomRateDetails'?: string;
    'total': Prices;
    /**
     * Model used to generify shared types across any product or payment type. The type of `Opaque`
is a shared value between the FE and BFF. As a result each implementation that uses an `Opaque`
can reuse existing models from other interfaces.
     * @type {any}
     * @memberof RoomProduct
     */
    'ancillaryOpaque'?: any;
    /**
     * program loyalty code from the hotel. None if hotel is ineligible for loyalty programs, or not implemented
     * @type {string}
     * @memberof RoomProduct
     */
    'loyaltyProgramCode'?: string;
    'hopperRateCategory'?: HopperRateCategory;
    /**
     * Model used to generify shared types across any product or payment type. The type of `Opaque`
is a shared value between the FE and BFF. As a result each implementation that uses an `Opaque`
can reuse existing models from other interfaces.
     * @type {any}
     * @memberof RoomProduct
     */
    'priceFreezeOpaque'?: any;
    /**
     * room rate amenities with additional details (if any)
     * @type {Array<AmenityStatus>}
     * @memberof RoomProduct
     */
    'amenities': Array<AmenityStatus>;
    'nightlyDiscountAwareTaxesAndFeesIncluded'?: DiscountAwarePrices;
    'promotion'?: LodgingPromotion;
    'perNightTotal': Prices;
    'totalDiscountAware': DiscountAwarePrices;
    'trackingPropertiesV2': TrackingProperties;
    /**
     * provider name
     * @type {string}
     * @memberof RoomProduct
     */
    'providerName': string;
    /**
     * list of discounts and description
     * @type {Array<Discount>}
     * @memberof RoomProduct
     */
    'discounts': Array<Discount>;
    'corporateTravel'?: ShopRoomProductCorporateTravel;
    /**
     * is a corporate rate - set from the provider - will have corporate specific discounts
     * @type {boolean}
     * @memberof RoomProduct
     */
    'isCorporate'?: boolean;
    'roomName'?: string;
    'totalDiscountAwareTaxesAndFeesIncluded'?: DiscountAwarePrices;
    'perNightBaseRate': Prices;
    'taxBreakdown': Taxes;
    'baseRate': Prices;
    'rateId'?: RateId;
    /**
     * Localized description of the experience the customer can expect from buying this product (meal plan, bath, extras, etc.
     * @type {string}
     * @memberof RoomProduct
     */
    'experienceDescription'?: string;
    'cancellationPolicyV2'?: CancellationPolicyV2;
    'providerOverrideText': ProviderOverrideText;
    'perNightSellRateTaxesAndFeesIncluded'?: Prices;
    'sellRate': Prices;
    /**
     * Encrypted, opaque request used to quote the room, for the same lodging
     * @type {any}
     * @memberof RoomProduct
     */
    'opaqueQuoteRequest': any;
    /**
     * additional policies
     * @type {Array<Policy>}
     * @memberof RoomProduct
     */
    'policies': Array<Policy>;
}


export const RoomType = {
    Bedroom: 'Bedroom',
    CommonArea: 'CommonArea',
    LivingRoom: 'LivingRoom',
    Loft: 'Loft'
} as const;

export type RoomType = typeof RoomType[keyof typeof RoomType];


export interface Rooms {
    'rooms': Array<Room>;
    'occupancy'?: number;
}
export interface RoomsList {
    'MerchandisingPlacement': MerchandisingPlacementEnum;
}


/**
 * number of rooms (default = 1)
 * @export
 * @interface RoomsSelection
 */
export interface RoomsSelection {
    'numberOfRooms': number;
}
/**
 * Filters for availability search to be forwarded to LSA
 * @export
 * @interface SearchRefinementOptions
 */
export interface SearchRefinementOptions {
    'minStarRating'?: HotelStarRating;
    'meals'?: Array<MealPlanRefinement>;
    'minUserRating'?: number;
    'fiatPriceRange'?: FiatPriceRange;
    'stayTypes'?: Array<StayType>;
    'amenities'?: Array<Amenity>;
    'starRating'?: Array<HotelStarRating>;
    'priceRangeUsd'?: PriceRange;
    'sort': LodgingSortOrder;
    'cancellationPolicies'?: Array<CancellationPolicyKind>;
}


/**
 * Unknown service error from Lodging stack
 * @export
 * @interface ServiceError
 */
export interface ServiceError {
    'msg': string;
    'LodgingError': LodgingErrorEnum;
}


/**
 * request for available rooms and prices
 * @export
 * @interface ShopRequest
 */
export interface ShopRequest {
    /**
     * Encrypted, opaque request used to shop rooms for the same available lodging
     * @type {any}
     * @memberof ShopRequest
     */
    'opaqueRequest': any;
    'locationSearchTerm'?: string;
}
/**
 * @type ShopResponse
 * list of available rooms and prices
 * @export
 */
export type ShopResponse = { ShopResponse: 'Available' } & ShopResponseAvailable | { ShopResponse: 'Failure' } & ShopResponseFailure | { ShopResponse: 'Unavailable' } & ShopResponseUnavailable;

/**
 * list of available rooms and prices

 * `lodgingCollection` - what lodging collection, if any, this result belongs to
 * `cancellationSummary` - Cancellation summary at a lodging level; this applies to all rooms under the lodging
 * `lodgingPriceChange` - price change (if any)
 * `opaqueCfarQuotesRequest` - encrypted request that the UI will pass to CFAR Quotes get API
 * `lodgingId` - id of lodge chosen
 * `roomInfoProducts` - list of rooms and prices
 * `isLuxuryCollection` - Deprecated, use lodgingCollection
 * @export
 * @interface ShopResponseAvailable
 */
export interface ShopResponseAvailable {
    'lodgingCollection': LodgingCollection;
    'cancellationSummary'?: CancellationSummary;
    'checkInInstructions'?: CheckInInstructions;
    'lodgingPriceChange'?: PriceChange;
    /**
     * Encrypted, opaque request used to pass Paris Shop response data to CFAR Quotes API
     * @type {any}
     * @memberof ShopResponseAvailable
     */
    'opaqueCfarQuotesRequest'?: any;
    /**
     * id of lodge chosen
     * @type {string}
     * @memberof ShopResponseAvailable
     */
    'lodgingId': string;
    /**
     * list of rooms and prices
     * @type {Array<RoomInfoProducts>}
     * @memberof ShopResponseAvailable
     */
    'roomInfoProducts': Array<RoomInfoProducts>;
    'ShopResponse': ShopResponseEnum;
    /**
     * Deprecated, use lodgingCollection
     * @type {boolean}
     * @memberof ShopResponseAvailable
     */
    'isLuxuryCollection': boolean;
    'trackingPropertiesV2': TrackingProperties;
}


export const ShopResponseEnum = {
    Available: 'Available',
    Failure: 'Failure',
    Unavailable: 'Unavailable'
} as const;

export type ShopResponseEnum = typeof ShopResponseEnum[keyof typeof ShopResponseEnum];


/**
 * failure to get list of available room
 * @export
 * @interface ShopResponseFailure
 */
export interface ShopResponseFailure {
    'ShopResponse': ShopResponseEnum;
}


/**
 * no available rooms
 * @export
 * @interface ShopResponseUnavailable
 */
export interface ShopResponseUnavailable {
    'ShopResponse': ShopResponseEnum;
}


export interface ShopRoomProductCorporateTravel {
    'policyCompliance': PolicyCompliance;
}
export interface Standalone {
    'MerchandisingPlacement': MerchandisingPlacementEnum;
}


export interface StateOrProvince {
    'code'?: string;
    'name'?: string;
}
/**
 * lodging types e.g. Homes, Hotels
 * @export
 * @enum {string}
 */

export const StayType = {
    Homes: 'Homes',
    Hotels: 'Hotels'
} as const;

export type StayType = typeof StayType[keyof typeof StayType];


export interface Suggestion {
    'subLabel'?: string;
    'label': string;
    'thumbnail'?: string;
    'id': PlaceId;
    'trackingPropertiesV2': TrackingProperties;
}
export interface Synthetic {
    'CfarBrand': CfarBrandEnum;
}


export interface SyntheticNegative {
    'CfarBrand': CfarBrandEnum;
}


export interface Taxes {
    'taxRecoveryCharges'?: Prices;
    'salesTax'?: Prices;
    'propertyFee'?: Prices;
    'cityTaxes'?: Prices;
}
/**
 * The taxes and fees total detail
 * @export
 * @interface TaxesAndFeesDetails
 */
export interface TaxesAndFeesDetails {
    'payNow'?: Prices;
    'payLater'?: Prices;
    'payLaterLocalCurrency'?: Prices;
    'breakdown'?: Breakdown;
}
/**
 * Highest level pricing summary. Includes only the final rate the user sees
 * @export
 * @interface TotalSummary
 */
export interface TotalSummary {
    'total': Prices;
    'LodgingPriceBreakdown': LodgingPriceBreakdownEnum;
}


export interface TrackedQuote {
    'quote': LodgingPriceQuote;
}
export interface TrackedQuoteFailed {
    'errors': Array<Error>;
    'Response': TrackedQuoteResponseEnum;
}


export interface TrackedQuotePending {
    'Response': TrackedQuoteResponseEnum;
}


/**
 * @type TrackedQuoteResponse
 * @export
 */
export type TrackedQuoteResponse = { Response: 'Failed' } & TrackedQuoteFailed | { Response: 'Pending' } & TrackedQuotePending | { Response: 'Success' } & TrackedQuoteSuccess;

export const TrackedQuoteResponseEnum = {
    Failed: 'Failed',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type TrackedQuoteResponseEnum = typeof TrackedQuoteResponseEnum[keyof typeof TrackedQuoteResponseEnum];


export interface TrackedQuoteSuccess {
    'value': TrackedQuote;
    'Response': TrackedQuoteResponseEnum;
}


/**
 * properties used for tracking and identifying the reservation
 * @export
 * @interface TrackingProperties
 */
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
/**
 * @type TravelWallet
 * @export
 */
export type TravelWallet = { TravelWallet: 'Credit' } & Credit | { TravelWallet: 'Offer' } & Offer;

export const TravelWalletEnum = {
    Credit: 'Credit',
    Offer: 'Offer'
} as const;

export type TravelWalletEnum = typeof TravelWalletEnum[keyof typeof TravelWalletEnum];


/**
 * `percentage` - Percentage discount amount for percentage offer
 * `offerType` - Type of the offer
 * `amount` - Discount amount in the specified currency
 * `imageId` - Image name that's set in the offer config
 * `maxDiscountAmount` - Max discount amount in the specified currency for percentage offer
 * @export
 * @interface TravelWalletOffer
 */
export interface TravelWalletOffer {
    /**
     * Percentage discount amount for percentage offer
     * @type {number}
     * @memberof TravelWalletOffer
     */
    'percentage'?: number;
    'shopPageBanner'?: string;
    'funnels': Array<Funnel>;
    'offerType': OfferType;
    'amount': Amount;
    'expiresOn': string;
    'availabilityPageBanner'?: string;
    'id': string;
    /**
     * Image name that's set in the offer config
     * @type {string}
     * @memberof TravelWalletOffer
     */
    'imageId'?: string;
    'trackingPropertiesV2': TrackingProperties;
    'termsAndConditions'?: string;
    'title': string;
    'landingPageBanner'?: string;
    'maxDiscountAmount'?: Amount;
    'descriptions': Array<string>;
}


export interface TripAdvisorCategory {
    'categoryName': string;
    /**
     * normalized rating value should be within range [0, 1]
     * @type {number}
     * @memberof TripAdvisorCategory
     */
    'score': number;
}
export interface TripAdvisorComment {
    'author': string;
    /**
     * normalized rating value should be within range [0, 1]
     * @type {number}
     * @memberof TripAdvisorComment
     */
    'score': number;
    'text': string;
    'title': string;
    'created': string;
}
/**
 * trip advisor reviews (if any)
 * @export
 * @interface TripAdvisorReviews
 */
export interface TripAdvisorReviews {
    'reviewsCount': number;
    /**
     * normalized rating value should be within range [0, 1]
     * @type {number}
     * @memberof TripAdvisorReviews
     */
    'overallScore': number;
    'categories': Array<TripAdvisorCategory>;
    'comments': Array<TripAdvisorComment>;
}
/**
 * The attempted quote is no longer available
 * @export
 * @interface Unavailable
 */
export interface Unavailable {
    'LodgingError': LodgingErrorEnum;
}


export interface UnknownPolicyV2 {
    'primaryText': string;
    'CancellationPolicyV2': CancellationPolicyV2Enum;
}


/**
 * Unrecognized enum value or serialization error
 * @export
 * @interface Unspecified
 */
export interface Unspecified {
    'LodgingError': LodgingErrorEnum;
}


/**
 * `cardType` - Type of card used in the transaction
 * `cardNumberDisplay` - User-friendly card number display. In most cases this is the last four digits of the card
 * @export
 * @interface UserCard
 */
export interface UserCard {
    'cardType': CardType;
    /**
     * User-friendly card number display. In most cases this is the last four digits of the card
     * @type {string}
     * @memberof UserCard
     */
    'cardNumberDisplay': string;
    'amount': FiatAmount;
    'PaymentLineItem': PaymentLineItemEnum;
}


export interface Video {
    'url': string;
    'thumbnail': string;
    'LodgingMediaAsset': LodgingMediaAssetEnum;
}


/**
 * `bestOfferOverall` - Best offer out of all offers for returned lodgings if exists
 * `offersByProductId` - LodgingId (ProductId) mapped to the corresponding best offer for the shopped lodging product
 * `opaqueProductMap` - LodgingId mapped to encrypted wallet model the FE passes back to the wallet /applicable endpoint to receive all wallet offers after a base product is chosen. This exists in lodging as there is no support for refetching a shopped hotel trip via API for external services
 * @export
 * @interface WalletOfferApplicabilityResponse
 */
export interface WalletOfferApplicabilityResponse {
    'bestOfferOverall'?: TravelWalletOffer;
    /**
     * LodgingId (ProductId) mapped to the corresponding best offer for the shopped lodging product
     * @type {{ [key: string]: TravelWalletOffer; }}
     * @memberof WalletOfferApplicabilityResponse
     */
    'offersByProductId': { [key: string]: TravelWalletOffer; };
    /**
     * LodgingId mapped to encrypted wallet model the FE passes back to the wallet /applicable endpoint to receive all wallet offers after a base product is chosen. This exists in lodging as there is no support for refetching a shopped hotel trip via API for external services
     * @type {{ [key: string]: string; }}
     * @memberof WalletOfferApplicabilityResponse
     */
    'opaqueProductMap': { [key: string]: string; };
}
/**
 * @type WatchGroupingKey
 * @export
 */
export type WatchGroupingKey = { WatchGroupingKey: 'MarketGroupingKey' } & MarketGroupingKey;

export const WatchGroupingKeyEnum = {
    MarketGroupingKey: 'MarketGroupingKey'
} as const;

export type WatchGroupingKeyEnum = typeof WatchGroupingKeyEnum[keyof typeof WatchGroupingKeyEnum];



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Autocomplete a lodging location, name, or coordinates
         * @param {LodgingQuery} lodgingQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AutocompleteLodgingPost: async (lodgingQuery: LodgingQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lodgingQuery' is not null or undefined
            assertParamExists('apiV0AutocompleteLodgingPost', 'lodgingQuery', lodgingQuery)
            const localVarPath = `/api/v0/autocomplete/lodging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lodgingQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all lodging inventory for a particular location
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HotelsAvailabilityPost: async (availabilityRequest: AvailabilityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityRequest' is not null or undefined
            assertParamExists('apiV0HotelsAvailabilityPost', 'availabilityRequest', availabilityRequest)
            const localVarPath = `/api/v0/hotels/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the Google Maps API key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HotelsGoogleMapsApiKeyPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/hotels/googleMapsApiKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shop for available rooms and prices
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HotelsShopPost: async (shopRequest: ShopRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopRequest' is not null or undefined
            assertParamExists('apiV0HotelsShopPost', 'shopRequest', shopRequest)
            const localVarPath = `/api/v0/hotels/shop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Quote instead.
         * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHotelsCancelPolicyPost: async (hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hotelCancellationPolicyRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHotelsCancelPolicyPost', 'hotelCancellationPolicyRequest', hotelCancellationPolicyRequest)
            const localVarPath = `/api/v0/selfserve/hotels/cancel/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hotelCancellationPolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Fulfill instead.
         * @param {HotelCancellationRequest} hotelCancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHotelsCancelPost: async (hotelCancellationRequest: HotelCancellationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hotelCancellationRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHotelsCancelPost', 'hotelCancellationRequest', hotelCancellationRequest)
            const localVarPath = `/api/v0/selfserve/hotels/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hotelCancellationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Change Quote instead.
         * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHotelsChangePolicyPost: async (hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hotelCancellationPolicyRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHotelsChangePolicyPost', 'hotelCancellationPolicyRequest', hotelCancellationPolicyRequest)
            const localVarPath = `/api/v0/selfserve/hotels/change/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hotelCancellationPolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all homes and hotels inventory for a particular location
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0StaysAvailabilityPost: async (availabilityRequest: AvailabilityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityRequest' is not null or undefined
            assertParamExists('apiV0StaysAvailabilityPost', 'availabilityRequest', availabilityRequest)
            const localVarPath = `/api/v0/stays/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch details for a single hotel reservation
         * @param {GetHotelReservationRequest} getHotelReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHotelGetReservationPut: async (getHotelReservationRequest: GetHotelReservationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getHotelReservationRequest' is not null or undefined
            assertParamExists('apiV0TripsHotelGetReservationPut', 'getHotelReservationRequest', getHotelReservationRequest)
            const localVarPath = `/api/v0/trips/hotel/getReservation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getHotelReservationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all of the hotel itineraries for a given user
         * @param {HotelItineraryRequest} hotelItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHotelPut: async (hotelItineraryRequest: HotelItineraryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hotelItineraryRequest' is not null or undefined
            assertParamExists('apiV0TripsHotelPut', 'hotelItineraryRequest', hotelItineraryRequest)
            const localVarPath = `/api/v0/trips/hotel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hotelItineraryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Autocomplete a lodging location, name, or coordinates
         * @param {LodgingQuery} lodgingQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AutocompleteLodgingPost(lodgingQuery: LodgingQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LodgingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AutocompleteLodgingPost(lodgingQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AutocompleteLodgingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all lodging inventory for a particular location
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0HotelsAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0HotelsAvailabilityPost(availabilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0HotelsAvailabilityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the Google Maps API key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0HotelsGoogleMapsApiKeyPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleMapsApiKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0HotelsGoogleMapsApiKeyPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0HotelsGoogleMapsApiKeyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Shop for available rooms and prices
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0HotelsShopPost(shopRequest: ShopRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0HotelsShopPost(shopRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0HotelsShopPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Quote instead.
         * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHotelsCancelPolicyPost(hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotelCancelScenarioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHotelsCancelPolicyPost(hotelCancellationPolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0SelfserveHotelsCancelPolicyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Fulfill instead.
         * @param {HotelCancellationRequest} hotelCancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHotelsCancelPost(hotelCancellationRequest: HotelCancellationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotelCancellationResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHotelsCancelPost(hotelCancellationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0SelfserveHotelsCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Change Quote instead.
         * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHotelsChangePolicyPost(hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotelCancelScenarioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHotelsChangePolicyPost(hotelCancellationPolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0SelfserveHotelsChangePolicyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all homes and hotels inventory for a particular location
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0StaysAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0StaysAvailabilityPost(availabilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0StaysAvailabilityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch details for a single hotel reservation
         * @param {GetHotelReservationRequest} getHotelReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0TripsHotelGetReservationPut(getHotelReservationRequest: GetHotelReservationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotelItinerary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0TripsHotelGetReservationPut(getHotelReservationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0TripsHotelGetReservationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all of the hotel itineraries for a given user
         * @param {HotelItineraryRequest} hotelItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0TripsHotelPut(hotelItineraryRequest: HotelItineraryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotelItineraryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0TripsHotelPut(hotelItineraryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0TripsHotelPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Autocomplete a lodging location, name, or coordinates
         * @param {LodgingQuery} lodgingQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AutocompleteLodgingPost(lodgingQuery: LodgingQuery, options?: RawAxiosRequestConfig): AxiosPromise<LodgingResponse> {
            return localVarFp.apiV0AutocompleteLodgingPost(lodgingQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all lodging inventory for a particular location
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HotelsAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityResponse> {
            return localVarFp.apiV0HotelsAvailabilityPost(availabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the Google Maps API key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HotelsGoogleMapsApiKeyPost(options?: RawAxiosRequestConfig): AxiosPromise<GoogleMapsApiKey> {
            return localVarFp.apiV0HotelsGoogleMapsApiKeyPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Shop for available rooms and prices
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HotelsShopPost(shopRequest: ShopRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopResponse> {
            return localVarFp.apiV0HotelsShopPost(shopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Quote instead.
         * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHotelsCancelPolicyPost(hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<HotelCancelScenarioResponse> {
            return localVarFp.apiV0SelfserveHotelsCancelPolicyPost(hotelCancellationPolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Fulfill instead.
         * @param {HotelCancellationRequest} hotelCancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHotelsCancelPost(hotelCancellationRequest: HotelCancellationRequest, options?: RawAxiosRequestConfig): AxiosPromise<HotelCancellationResultResponse> {
            return localVarFp.apiV0SelfserveHotelsCancelPost(hotelCancellationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Change Quote instead.
         * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHotelsChangePolicyPost(hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<HotelCancelScenarioResponse> {
            return localVarFp.apiV0SelfserveHotelsChangePolicyPost(hotelCancellationPolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all homes and hotels inventory for a particular location
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0StaysAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityResponse> {
            return localVarFp.apiV0StaysAvailabilityPost(availabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch details for a single hotel reservation
         * @param {GetHotelReservationRequest} getHotelReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHotelGetReservationPut(getHotelReservationRequest: GetHotelReservationRequest, options?: RawAxiosRequestConfig): AxiosPromise<HotelItinerary> {
            return localVarFp.apiV0TripsHotelGetReservationPut(getHotelReservationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all of the hotel itineraries for a given user
         * @param {HotelItineraryRequest} hotelItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHotelPut(hotelItineraryRequest: HotelItineraryRequest, options?: RawAxiosRequestConfig): AxiosPromise<HotelItineraryResponse> {
            return localVarFp.apiV0TripsHotelPut(hotelItineraryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Autocomplete a lodging location, name, or coordinates
     * @param {LodgingQuery} lodgingQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AutocompleteLodgingPost(lodgingQuery: LodgingQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AutocompleteLodgingPost(lodgingQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all lodging inventory for a particular location
     * @param {AvailabilityRequest} availabilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0HotelsAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0HotelsAvailabilityPost(availabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the Google Maps API key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0HotelsGoogleMapsApiKeyPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0HotelsGoogleMapsApiKeyPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shop for available rooms and prices
     * @param {ShopRequest} shopRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0HotelsShopPost(shopRequest: ShopRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0HotelsShopPost(shopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Quote instead.
     * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHotelsCancelPolicyPost(hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHotelsCancelPolicyPost(hotelCancellationPolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Cancel Fulfill instead.
     * @param {HotelCancellationRequest} hotelCancellationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHotelsCancelPost(hotelCancellationRequest: HotelCancellationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHotelsCancelPost(hotelCancellationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [Deprecated] This endpoint is deprecated for any portal using shopping cart, Self-serve cancellation of lodging.Use LodgingCancelApi Change Quote instead.
     * @param {HotelCancellationPolicyRequest} hotelCancellationPolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHotelsChangePolicyPost(hotelCancellationPolicyRequest: HotelCancellationPolicyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHotelsChangePolicyPost(hotelCancellationPolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all homes and hotels inventory for a particular location
     * @param {AvailabilityRequest} availabilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0StaysAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0StaysAvailabilityPost(availabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch details for a single hotel reservation
     * @param {GetHotelReservationRequest} getHotelReservationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0TripsHotelGetReservationPut(getHotelReservationRequest: GetHotelReservationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0TripsHotelGetReservationPut(getHotelReservationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all of the hotel itineraries for a given user
     * @param {HotelItineraryRequest} hotelItineraryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0TripsHotelPut(hotelItineraryRequest: HotelItineraryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0TripsHotelPut(hotelItineraryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



